import { t as e } from "./AppLocales-BhP8HhaO.js";
import { z as t } from "zod";
//#region src/utils/isDefined.ts
var n = (e) => e != null, r = (e, t) => {
	if (!n(e)) throw t ?? /* @__PURE__ */ Error("Expected value to be defined");
}, i = (e, t) => {
	throw Error(t ?? `Unexpected value: ${String(e)}`);
}, a = (e) => e.length === 0 ? e : `${e.charAt(0).toUpperCase()}${e.slice(1)}`, o = (e) => e.replace(/[\\%_]/g, (e) => `\\${e}`), s = (e, t, r) => {
	let i = e.find(t);
	if (!n(i)) throw r ?? /* @__PURE__ */ Error("No item matches the predicate");
	return i;
}, c = (e, t) => {
	if (e === null && t === null) return null;
	let n = e === null ? NaN : new Date(e).getTime(), r = t === null ? NaN : new Date(t).getTime();
	if (!Number.isFinite(n) || !Number.isFinite(r) || n >= r) throw RangeError("Warning intervals require valid paired dates with end after start.");
	return {
		startsAt: n,
		endsAt: r
	};
}, l = (e, t) => e.flatMap((e) => e.status === "cancelled" ? [] : e.assignments.flatMap((n) => {
	if (t?.collaboratorIds && !t.collaboratorIds.includes(n.collaboratorId)) return [];
	let r = n.startsAt === null && n.endsAt === null ? c(e.startsAt, e.endsAt) : c(n.startsAt, n.endsAt);
	return r ? [{
		interventionId: e.id,
		collaboratorId: n.collaboratorId,
		...r
	}] : [];
})), u = (...e) => {
	let t = Math.max(...e.map((e) => e.startsAt)), n = Math.min(...e.map((e) => e.endsAt));
	return t < n ? {
		startsAt: new Date(t).toISOString(),
		endsAt: new Date(n).toISOString()
	} : null;
}, d = (e) => [...new Map(e.map((e) => [JSON.stringify([
	e.code,
	e.interventionId,
	e.collaboratorId,
	e.startsAt,
	e.endsAt
]), e])).entries()].sort(([e], [t]) => e < t ? -1 : +(e > t)).map(([, e]) => e), f = (e, t, n) => {
	let r = n ? c(n.startsAt, n.endsAt) : null, i = [];
	for (let a of l(e, n)) for (let e of t) {
		if (e.collaboratorId !== a.collaboratorId) continue;
		let t = c(e.startsAt, e.endsAt);
		if (!t) continue;
		let n = u(a, t, ...r ? [r] : []);
		n && i.push({
			code: "R2",
			interventionId: a.interventionId,
			collaboratorId: a.collaboratorId,
			...n
		});
	}
	return d(i);
}, p = (e, t) => {
	let n = l(e, t), r = t ? c(t.startsAt, t.endsAt) : null, i = [];
	for (let [e, t] of n.entries()) for (let a of n.slice(e + 1)) {
		if (t.collaboratorId !== a.collaboratorId || t.interventionId === a.interventionId) continue;
		let e = u(t, a, ...r ? [r] : []);
		if (e) for (let n of [t, a]) i.push({
			code: "R1",
			interventionId: n.interventionId,
			collaboratorId: n.collaboratorId,
			...e
		});
	}
	return d(i);
}, ee = (e, t) => {
	let n = t ? c(t.startsAt, t.endsAt) : null;
	return d(e.flatMap((e) => {
		if (e.status !== "planned" || e.assignments.length > 0) return [];
		let t = c(e.startsAt, e.endsAt), r = t ? u(t, ...n ? [n] : []) : null;
		return r ? [{
			code: "R3",
			interventionId: e.id,
			collaboratorId: null,
			...r
		}] : [];
	}));
}, te = (e, t, n) => d([
	...p(e, n),
	...f(e, t, n),
	...ee(e, n)
]), ne = globalThis.Temporal, re = (e, t) => `Non-positive ${e}: ${t}`, ie = (e, t) => `Non-finite ${e}: ${t}`, ae = (e) => `Cannot convert bigint to ${e}`, oe = "Invalid object", se = (e, t, n, r) => ce(e, t) + `; must be between ${n}-${r}`, ce = (e, t) => `Invalid ${e}: ${t}`, le = 1e3, ue = 1e6, de = 1e9, fe = 6e10, pe = 36e11;
function me(e) {
	return e === void 0 ? Object.create(null) : be(e);
}
function he(e, t = "number") {
	if (typeof e == "bigint") throw TypeError(ae(t));
	if (e = Number(e), !Number.isFinite(e)) throw RangeError(ie(t, e));
	return e;
}
function m(e, t) {
	return Math.trunc(he(e, t)) || 0;
}
function ge(e, t) {
	return _e(m(e, t), t);
}
function _e(e, t = "number") {
	if (e <= 0) throw RangeError(re(t, e));
	return e;
}
function ve(e, t, n) {
	return Math.min(Math.max(e, t), n);
}
function ye(e) {
	return e !== null && (typeof e == "object" || typeof e == "function");
}
function be(e) {
	if (!ye(e)) throw TypeError(oe);
	return e;
}
//#endregion
//#region ../../node_modules/temporal-polyfill/chunks/options.js
function xe(e, t) {
	return typeof e == "string" ? ((e, t) => {
		let n = Object.create(null);
		return n[e] = t, n;
	})(t, e) : be(e);
}
var Se = "smallestUnit", Ce = {
	constrain: 0,
	reject: 1
}, we = {
	compatible: 0,
	reject: 1,
	earlier: 2,
	later: 3
}, Te = {
	reject: 0,
	use: 1,
	prefer: 2,
	ignore: 3
}, Ee = {
	auto: 0,
	never: 1,
	critical: 2,
	always: 3
}, De = {
	auto: 0,
	never: 1,
	critical: 2
}, Oe = {
	auto: 0,
	never: 1
}, ke = {
	floor: 0,
	halfFloor: 1,
	ceil: 2,
	halfCeil: 3,
	trunc: 4,
	halfTrunc: 5,
	expand: 6,
	halfExpand: 7,
	halfEven: 8
}, Ae = [
	Math.floor,
	$t,
	Math.ceil,
	en,
	Math.trunc,
	tn,
	Xt,
	Qt,
	nn
], je = {
	previous: -1,
	next: 1
};
function Me(e) {
	let t = e.roundingIncrement;
	return t === void 0 ? 1 : m(t, "roundingIncrement");
}
function Ne(e) {
	let t = e.fractionalSecondDigits;
	if (t !== void 0) {
		if (typeof t != "number") {
			if (ai(t) === "auto") return;
			_(ut("fractionalSecondDigits", t));
		}
		t = Tt("fractionalSecondDigits", Math.floor(t), 0, 9, 1);
	}
	return t;
}
function Pe(e, t, n = 0, r) {
	let i = t[e];
	if (i === void 0) return r ? n : void 0;
	if (i = ai(i), i === "auto") return r ? n : null;
	let a = pn[i];
	return a === void 0 && (a = k.indexOf(i)), a < 0 && _(pt(e, i, pn)), a;
}
function Fe(e, t, n, r = 0) {
	let i = n[e];
	if (i === void 0) return r;
	let a = ai(i), o = t[a];
	return o === void 0 && _(pt(e, a, t)), o;
}
var Ie = /*@__PURE__*/ y(Pe, Se), Le = /*@__PURE__*/ y(Pe, "largestUnit"), Re = /*@__PURE__*/ y(Pe, "unit"), ze = /*@__PURE__*/ y(Fe, "overflow", Ce), Be = /*@__PURE__*/ y(Fe, "disambiguation", we), Ve = /*@__PURE__*/ y(Fe, "offset", Te), He = /*@__PURE__*/ y(Fe, "calendarName", Ee), Ue = /*@__PURE__*/ y(Fe, "timeZoneName", De), We = /*@__PURE__*/ y(Fe, "offset", Oe), Ge = /*@__PURE__*/ y(Fe, "roundingMode", ke), Ke = /*@__PURE__*/ y(Fe, "direction", je);
function qe(e, t, n, r) {
	let i = r ? bn : C[t + 1];
	if (i) {
		let n = C[t];
		i % ((e = Tt("roundingIncrement", e, 1, i / n - +!r, 1)) * n) && _(ut("roundingIncrement", e));
	} else e = Tt("roundingIncrement", e, 1, n ? 10 ** 9 : 1, 1);
	return e;
}
function Je(e, t, n, r) {
	return t != null && Tt(e, t, n, r, 1, mn), t;
}
function Ye(e, t) {
	t > e && _("smallestUnit > largestUnit");
}
function Xe(e, t, n, r = 9, i = 0, a = 4) {
	t = me(t);
	let o = Le(t, i), s = Me(t), c = Ge(t, a), l = Ie(t, i, 1);
	return o = Je("largestUnit", o, i, r), l = Je(Se, l, i, r), o == null ? o = Math.max(n, l) : Ye(o, l), s = qe(s, l, 1), e && (c = ((e) => e < 4 ? (e + 2) % 4 : e)(c)), [
		o,
		l,
		s,
		c
	];
}
function Ze(e, t, n) {
	e = xe(e, Se);
	let r = Le(e), i = n(e.relativeTo), a = Me(e), o = Ge(e, 7), s = Ie(e);
	return r === void 0 && s === void 0 && _("Required smallestUnit or largestUnit"), s ??= 0, r ??= Math.max(s, t), Ye(r, s), a = qe(a, s, 1), a > 1 && s > 5 && r !== s && _("For calendar units with roundingIncrement > 1, use largestUnit = smallestUnit"), [
		r,
		s,
		a,
		o,
		i
	];
}
function Qe(e, t = 6, n) {
	let r = Me(e = xe(e, Se)), i = Ge(e, 7), a = Ie(e);
	return a = ni(Se, a), a = Je(Se, a, 0, t), r = qe(r, a, void 0, n), [
		a,
		r,
		i
	];
}
function $e(e, t) {
	let n = t((e = xe(e, "unit")).relativeTo), r = Re(e);
	return r = ni("unit", r), [r, n];
}
function h(e) {
	return e === void 0 ? 0 : ze(be(e));
}
function et(e, t = 0) {
	e = me(e);
	let n = Be(e), r = Ve(e, t);
	return [
		ze(e),
		r,
		n
	];
}
function tt(e) {
	return Be(me(e));
}
function nt(e, t = 4) {
	let n = Ne(e);
	return [Ge(e, 4), ...ct(Je(Se, Ie(e), 0, t), n)];
}
function rt(e) {
	return e = me(e), [He(e), ...nt(e)];
}
function it(e) {
	return He(me(e));
}
function at(e, t) {
	return nt(me(e), t);
}
function ot(e) {
	e = me(e);
	let t = He(e), n = Ne(e), r = We(e), i = Ge(e, 4), a = Ie(e);
	return [
		t,
		Ue(e),
		r,
		i,
		...ct(Je(Se, a, 0, 4), n)
	];
}
function st(e) {
	let t = Ne(e = me(e)), n = Ge(e, 4), r = Ie(e);
	return [
		e.timeZone,
		n,
		...ct(Je(Se, r, 0, 4), t)
	];
}
function ct(e, t) {
	return e == null ? [t === void 0 ? 1 : 10 ** (9 - t), t] : [C[e], e < 4 ? 9 - 3 * e : -1];
}
function lt(e) {
	let t = Ke(xe(e, "direction"), 0);
	return t || _(ut("direction", t)), t;
}
//#endregion
//#region ../../node_modules/temporal-polyfill/chunks/internal.js
var ut = ce, dt = (e) => `Missing ${e}`, ft = (e) => "No valid fields: " + e.join(), pt = (e, t, n) => ce(e, t) + "; must be " + Object.keys(n).join(), mt = "Cannot use valueOf", ht = "Invalid calling context", gt = (e) => "Missing year" + (e ? "/era/eraYear" : ""), _t = "Invalid leap month", vt = (e) => ce("Calendar", e), yt = (e, t) => `Unknown calendar ${e}; might need ${t}`, bt = (e) => ce("TimeZone", e), xt = (e) => `Cannot parse: ${e}`, St = (e) => `Invalid substring: ${e}`, Ct = ve, g = ye;
function _(e) {
	throw RangeError(e);
}
function v(e) {
	throw TypeError(e);
}
function wt(e, t, n, r, i) {
	return Tt(t, ((e, t) => {
		let n = e[t];
		return n === void 0 && v(dt(t)), n;
	})(e, t), n, r, i);
}
function Tt(e, t, n, r, i, a) {
	let o = Ct(t, n, r);
	return i && t !== o && _(((e, t, n, r, i) => i ? se(e, i[t], i[n], i[r]) : se(e, t, n, r))(e, t, n, r, a)), o;
}
function Et(e, t = Map) {
	let n = new t();
	return (t, ...r) => {
		if (n.has(t)) return n.get(t);
		let i = e(t, ...r);
		return n.set(t, i), i;
	};
}
var Dt = (e) => Ot({ name: e }, 1), Ot = (e, t) => At((e) => ({
	value: e,
	configurable: 1,
	writable: !t
}), e), kt = (e) => ({ [Symbol.toStringTag]: {
	value: e,
	configurable: 1
} });
function At(e, t) {
	let n = {};
	for (let r in t) n[r] = e(t[r], r);
	return n;
}
function jt(e, t) {
	let n = {};
	for (let r of e) n[r] = t;
	return n;
}
function Mt(e) {
	let t = {};
	for (let n of e) t[n] = (e) => e[n];
	return t;
}
function Nt(e, t, n = Object.create(null)) {
	for (let r of e) n[r] = t[r];
	return n;
}
function Pt(e, t, n) {
	for (let r of e) if (t[r] !== n[r]) return 0;
	return 1;
}
function Ft(e, t, n) {
	let r = { ...n };
	for (let n = 0; n < t; n++) r[e[n]] = 0;
	return r;
}
function y(e, ...t) {
	return (...n) => e(...t, ...n);
}
function It() {}
function Lt(e) {
	return e[0].toUpperCase() + e.substring(1);
}
function b(...e) {
	return [].concat(...e).sort();
}
function Rt(e) {
	return RegExp(`^${e}$`, "i");
}
function zt(e) {
	return parseInt(e.padEnd(9, "0"));
}
function Bt(e) {
	return e && e !== "+" ? -1 : 1;
}
function Vt(e) {
	return e === void 0 ? 0 : parseInt(e);
}
function Ht(e, t) {
	return String(t).padStart(e, "0");
}
var x = /*@__PURE__*/ y(Ht, 2);
function Ut(e, t) {
	return Math.sign(e - t);
}
function S(e, t) {
	return e < t ? -1 : +(e > t);
}
function Wt(e, t) {
	let n = e / t;
	return e % t < 0n ? n - 1n : n;
}
function Gt(e, t) {
	let n = Wt(e, t);
	return [n, e - n * t];
}
function Kt(e, t) {
	return [Math.floor(e / t), qt(e, t)];
}
function qt(e, t) {
	return (e % t + t) % t;
}
function Jt(e, t) {
	return Math.trunc(e / t) || 0;
}
function Yt(e, t) {
	return e % t || 0;
}
function Xt(e) {
	return e < 0 ? Math.floor(e) : Math.ceil(e);
}
function Zt(e, t = 1) {
	return t * (.5 + e / 5);
}
function Qt(e) {
	return Math.sign(e) * Math.round(Math.abs(e)) || 0;
}
function $t(e) {
	return rn(e) ? Math.floor(e) : Math.round(e);
}
function en(e) {
	return rn(e) ? Math.ceil(e) : Math.round(e);
}
function tn(e) {
	return rn(e) ? Math.trunc(e) || 0 : Math.round(e);
}
function nn(e) {
	return rn(e) ? (e = Math.trunc(e) || 0) + e % 2 : Math.round(e);
}
function rn(e) {
	return Math.abs(e % 1) === .5;
}
var an = "iso8601", on = {
	bce: -1,
	ce: 0
};
function sn(e) {
	let t = e.normalize("NFD").toLowerCase().replace(/[^a-z0-9]/g, "");
	return t === "bc" || t === "b" ? "bce" : t === "ad" || t === "a" ? "ce" : t;
}
function cn(e) {
	return e === void 0 ? "iso8601" : e === 0 ? "gregory" : e.id;
}
var ln = /^M(\d{2})(L?)$/;
function un(e) {
	let t = ln.exec(e);
	return t || _(((e) => `Invalid monthCode: ${e}`)(e)), [parseInt(t[1]), !!t[2]];
}
function dn(e, t) {
	return "M" + x(e) + (t ? "L" : "");
}
function fn(e, t, n) {
	return e + (t || n && e >= n ? 1 : 0);
}
var pn = {
	nanosecond: 0,
	microsecond: 1,
	millisecond: 2,
	second: 3,
	minute: 4,
	hour: 5,
	day: 6,
	week: 7,
	month: 8,
	year: 9
}, mn = /*@__PURE__*/ Object.keys(pn), hn = le, gn = ue, _n = de, vn = fe, yn = pe, bn = 864e11, C = [
	1,
	hn,
	gn,
	_n,
	vn,
	yn,
	bn
], xn = /*@__PURE__*/ BigInt(hn), Sn = /*@__PURE__*/ BigInt(gn), Cn = /*@__PURE__*/ BigInt(_n), wn = /*@__PURE__*/ BigInt(vn), Tn = /*@__PURE__*/ BigInt(yn), w = /*@__PURE__*/ BigInt(bn);
function En(e, t) {
	let n = Number(e / w), r = Number(e % w);
	return bn / t * n + (Math.trunc(r / t) + r % t / t);
}
var T = /*@__PURE__*/ mn.slice(0, 6), Dn = /*@__PURE__*/ Mt(T), On = ["year"], kn = ["day"], An = [
	"day",
	"month",
	"year"
], jn = ["offset"], Mn = ["timeZone"], Nn = ["era", "eraYear"], Pn = [
	"era",
	"eraYear",
	"year"
], Fn = ["month", "monthCode"], In = [
	"day",
	"month",
	"monthCode"
], Ln = /*@__PURE__*/ b(T), Rn = /*@__PURE__*/ b(Nn, On), zn = /*@__PURE__*/ b(Fn, On), Bn = /*@__PURE__*/ b(Nn, zn), Vn = /*@__PURE__*/ b(["monthCode"], On), Hn = /*@__PURE__*/ b(Nn, Vn), Un = /*@__PURE__*/ b(kn, ["monthCode"]), Wn = /*@__PURE__*/ b(kn, zn), Gn = /*@__PURE__*/ b(kn, Nn, zn), Kn = /*@__PURE__*/ b(Wn, T), qn = /*@__PURE__*/ b(Gn, T), Jn = /*@__PURE__*/ b(Wn, T, jn), Yn = /*@__PURE__*/ b(Gn, T, jn), Xn = /*@__PURE__*/ b(Wn, T, jn, Mn), Zn = /*@__PURE__*/ b(Gn, T, jn, Mn), Qn = /*@__PURE__*/ b(kn, Vn), $n = /*@__PURE__*/ b(kn, Nn, Vn), er = /*@__PURE__*/ jt(T, 0);
function tr(e) {
	return rr(e, 1), e;
}
var nr = {
	hour: 23,
	minute: 59,
	second: 59
};
function rr(e, t) {
	let n = {};
	for (let r of T) n[r] = Tt(r, e[r], 0, nr[r] || 999, t);
	return n;
}
function E(e) {
	return ar(e) * _n + or(e);
}
function ir(e) {
	return 1e3 * ar(e) + e.millisecond;
}
function ar(e) {
	return 3600 * e.hour + 60 * e.minute + e.second;
}
function or(e) {
	return e.millisecond * gn + e.microsecond * hn + e.nanosecond;
}
function sr(e) {
	let [t, n] = Kt(e, bn);
	return [cr(n), t];
}
function cr(e) {
	let [t, n] = Kt(e, gn), [r, i] = Kt(n, hn);
	return lr(t, r, i);
}
function lr(e, t = 0, n = 0) {
	let [r, i] = Kt(e, 36e5), [a, o] = Kt(i, 6e4), [s, c] = Kt(o, 1e3);
	return {
		hour: r,
		minute: a,
		second: s,
		millisecond: c,
		microsecond: t,
		nanosecond: n
	};
}
function ur(e) {
	let [t, n] = Gt(e, Cn);
	return [Number(t), Number(n)];
}
function dr(e) {
	return Number(Wt(e, Sn));
}
function D(e) {
	return pr(e) + BigInt(E(e));
}
function fr(e) {
	return mr(e) + ir(e);
}
function pr(e) {
	return BigInt(hr(e)) * w;
}
function mr(e) {
	return 864e5 * hr(e);
}
function hr(e) {
	return gr(e.year, e.month, e.day);
}
function gr(e, t = 1, n = 1) {
	let r = t - 1;
	return e += Math.floor(r / 12), t = qt(r, 12), Date.UTC(e % 400 - 400, t, 0) / 864e5 + 146097 * (Jt(e, 400) + 1) + n;
}
function _r(e) {
	let [t, n] = Gt(e, w);
	return {
		...vr(Number(t)),
		...cr(Number(n))
	};
}
function vr(e) {
	let t = /* @__PURE__ */ new Date(864e5 * qt(e, 146097));
	return {
		year: t.getUTCFullYear() + 400 * Math.floor(e / 146097),
		month: t.getUTCMonth() + 1,
		day: t.getUTCDate()
	};
}
function yr(e) {
	return [e, 0];
}
function br(e, t) {
	if (!t) return {
		year: 1972,
		month: e
	};
}
function xr(e, t, n) {
	return {
		year: e,
		month: t,
		day: n
	};
}
function Sr(e, t) {
	switch (t) {
		case 2: return wr(e) ? 29 : 28;
		case 4:
		case 6:
		case 9:
		case 11: return 30;
	}
	return 31;
}
function Cr(e) {
	return wr(e) ? 366 : 365;
}
function wr(e) {
	return e % 4 == 0 && (e % 100 != 0 || e % 400 == 0);
}
function Tr(e, t, n) {
	return e += Jt(n, 12), (t += Yt(n, 12)) < 1 ? (e--, t += 12) : t > 12 && (e++, t -= 12), {
		year: e,
		month: t
	};
}
function Er(e, t, n, r) {
	return 12 * (n - e) + r - t;
}
function Dr(e) {
	return qt(gr(e.year, e.month, e.day) + 4, 7) || 7;
}
function Or(e) {
	return gr(e.year, e.month, e.day) - gr(e.year) + 1;
}
function kr(e) {
	let t = e.year, n = Math.floor((Or(e) - Dr(e) + 10) / 7), r = Ar(t);
	return n < 1 ? n = r = Ar(--t) : n > r && (n = 1, r = Ar(++t)), {
		weekOfYear: n,
		yearOfWeek: t,
		De: r
	};
}
function Ar(e) {
	let t = Dr({
		year: e,
		month: 1,
		day: 1
	});
	return t === 4 || t === 3 && wr(e) ? 53 : 52;
}
function jr({ year: e }) {
	return e < 1 ? {
		era: "bce",
		eraYear: 1 - e
	} : {
		era: "ce",
		eraYear: e
	};
}
function Mr(e) {
	return Nr(e), tr(e);
}
function Nr(e) {
	return Fr(e, 1), e;
}
function Pr(e) {
	return Pt(An, e, Fr(e));
}
function Fr(e, t) {
	let { year: n } = e, r = wt(e, "month", 1, 12, t);
	return {
		year: n,
		month: r,
		day: wt(e, "day", 1, Sr(n, r), t)
	};
}
function O(e, t) {
	return e ? e.de(t) : t;
}
function Ir(e, t, n) {
	return e ? e.N(t, n) : yr(n);
}
function Lr(e, t) {
	return e === 0 ? jr(t) : e && e.h?.(t) || {};
}
function Rr(e, t, n, r) {
	return e ? e.fe(t, n, r) : xr(t, n, r);
}
function zr(e, t) {
	return e ? e.j(t) : 12;
}
function Br(e, t, n) {
	return e ? e.o(t, n) : Sr(t, n);
}
function Vr(e, t) {
	let { year: n, month: r } = O(e, t), [i, a] = Ir(e, n, r);
	return dn(i, a);
}
function Hr(e, t) {
	let { year: n } = O(e, t);
	return e ? e.q(n) : wr(n);
}
function Ur(e, t) {
	let { year: n } = O(e, t);
	return zr(e, n);
}
function Wr(e, t) {
	let { year: n, month: r } = O(e, t);
	return Br(e, n, r);
}
function Gr(e, t) {
	let { year: n } = O(e, t);
	return e ? e.i(n) : Cr(n);
}
function Kr(e, t) {
	if (!e) return Or(t);
	let { year: n } = O(e, t), r = Rr(e, n, 1, 1);
	return hr(t) - hr(r) + 1;
}
function qr(e, t) {
	return e === void 0 ? kr(t).weekOfYear : void 0;
}
function Jr(e, t) {
	return e === void 0 ? kr(t).yearOfWeek : void 0;
}
var k = /*@__PURE__*/ mn.map((e) => e + "s"), Yr = /*@__PURE__*/ Mt(k), Xr = /*@__PURE__*/ b(k), Zr = /*@__PURE__*/ k.slice(0, 6), Qr = /*@__PURE__*/ k.slice(6), $r = /*@__PURE__*/ Qr.slice(1), A = /*@__PURE__*/ jt(k, 0), ei = /*@__PURE__*/ jt(Zr, 0), ti = /*@__PURE__*/ y(Ft, k);
function ni(e, t) {
	return t ?? _(dt(e)), t;
}
var j = /*@__PURE__*/ y(ri, "string");
function ri(e, t, n = e) {
	return typeof t !== e && v(ut(n, t)), t;
}
function ii(e, t = "number") {
	return Number.isInteger(e) || _(((e, t) => `Non-integer ${e}: ${t}`)(t, e)), e || 0;
}
function ai(e) {
	return typeof e == "symbol" && v("Cannot convert Symbol to string"), String(e);
}
function oi(e) {
	if (!ye(e)) return e;
	let t = e[Symbol.toPrimitive];
	if (t != null) {
		typeof t != "function" && v();
		let n = Reflect.apply(t, e, ["string"]);
		return ye(n) && v(), n;
	}
	return Date.prototype[Symbol.toPrimitive].call(e, "string");
}
function si(e) {
	return typeof e == "boolean" ? BigInt(+!!e) : typeof e == "string" ? BigInt(e) : (typeof e != "bigint" && v(`Invalid bigint: ${e}`), e);
}
function ci(e, t) {
	return ii(he(e, t), t);
}
function M(e, t) {
	return Nt(An, e, Nt(T, t));
}
var li = /*@__PURE__*/ BigInt(1e8) * w, ui = /*@__PURE__*/ BigInt(-1e8) * w, di = ui - w, fi = -3261848;
function pi(e) {
	let t = 12 * e.year + e.month;
	return (t < fi || t > 3309129) && _("Out-of-bounds date"), e;
}
function N(e, t = 1) {
	let n = pr(e);
	return (n < (t ? di : ui) || n > li) && _("Out-of-bounds date"), e;
}
function mi(e) {
	return hi(D(e)), e;
}
function hi(e) {
	return (e <= di || e >= li + w) && _("Out-of-bounds date"), e;
}
function gi(e) {
	return (e < ui || e > li) && _("Out-of-bounds date"), e;
}
function _i(e, t) {
	return gi(pr(e) + BigInt(E(e) - t));
}
function vi(e, t, n) {
	return yi(e / t, n) * t;
}
function yi(e, t) {
	return Ae[t](e);
}
function bi(e, t, n, r) {
	let i = Si(e, t, r, n);
	return wi(i, Number(n - i.I) / Number(i.O - i.I));
}
function xi(e, t, n, r) {
	return vi(wi(e, Ti(t, e.I, e.O)), n, r);
}
function Si(e, t, n, r) {
	let i = Ci(e, t, n);
	return ((e, t, n, r) => r > 0 ? t <= e && e <= n : n <= e && e <= t)(r, i.I, i.O, Math.sign(t)) || (i = Ci(e + t, t, n)), i;
}
function Ci(e, t, n) {
	let r = e + t;
	return {
		ve: e,
		qe: r,
		I: n(e),
		O: n(r)
	};
}
function wi(e, t) {
	return e.ve + t * (e.qe - e.ve);
}
function Ti(e, t, n) {
	let r = n - t, i = e - t;
	if (!i) return 0;
	let a = i < 0n ? -i : i, o = r < 0n ? -r : r, s = S(i, 0n) === S(r, 0n) ? 1 : -1;
	return S(a, o) <= 0 ? a === o ? s : Zt(S(2n * a, o), s) : Number(i) / Number(r);
}
function P(e) {
	return { epochNanoseconds: e };
}
function F(e, t, n) {
	return {
		calendar: n,
		timeZone: t,
		epochNanoseconds: e
	};
}
function Ei(e, t) {
	return Nt(T, e, I(e, t));
}
function I(e, t) {
	return Nt(An, e, { calendar: t });
}
function Di(e) {
	return Nt(T, e);
}
function Oi(e) {
	return Nt(k, e, { sign: Ua(e) });
}
function ki(e, t, n, r) {
	return F(t === 6 ? Pi(e, r) : Fi(e, t, n, r), e.timeZone, e.calendar);
}
function Ai(e) {
	let [t, n] = Vi(e);
	return En(n - t, yn);
}
function ji(e) {
	let { timeZone: t, calendar: n } = e;
	return F(Qi(t, M(L(e), er)), t, n);
}
function Mi(e, t, n, r, i, a, o, s) {
	if (r === 0 && i === 1) return e;
	let c = Ua(e) || 1, [l, u, d] = (Fa(r, s) ? s && r < 6 && n >= 6 ? zi : Bi : Ri)(c, e, t, n, r, i, a, o);
	return d && r !== 7 && (l = ((e, t, n, r, i, a) => {
		for (let o = r + 1; o <= n; o++) {
			if (o === 7 && n !== 7) continue;
			let r = ti(o, e);
			r[k[o]] += i;
			let s = S(t, ja(a, r));
			if (s && s !== i) break;
			e = r;
		}
		return e;
	})(l, u, n, Math.max(6, r), c, o)), l;
}
function Ni(e, t, n) {
	let r = Math.min($a(e), 6);
	return Xa(Wi(qa(e), BigInt(t), n), r);
}
function Pi(e, t) {
	let [n, r] = Vi(e);
	return Hi(e.epochNanoseconds, n, r, t);
}
function Fi(e, t, n, r) {
	if (t === 0 && n === 1) return e.epochNanoseconds;
	let i = L(e);
	return Xi(e.timeZone, Ii(i, qi(t, n), r), i.offsetNanoseconds, 2, 0, 1);
}
function Ii(e, t, n) {
	let [r, i] = Li(e, t, n), a = M(da(e, i), r);
	return mi(a), a;
}
function Li(e, t, n) {
	return sr(vi(E(e), t, n));
}
function Ri(e, t, n, r, i, a, o, s) {
	let c = k[i], l = ti(i, t);
	i === 7 && (t = {
		...t,
		weeks: t.weeks + Math.trunc(t.days / 7)
	});
	let u = Jt(t[c], a) * a, d = Si(u, a * e, (e) => (l[c] = e, ja(s, l)), n), f = xi(d, n, a, o);
	return l[c] = f, [
		l,
		f === d.qe ? d.O : d.I,
		f !== u
	];
}
function zi(e, t, n, r, i, a, o, s) {
	let c = Number(Ja(t)), l = qi(i, a), u = vi(c, l, o), d = {
		...t,
		...ei
	}, f = Si(d.days, e, (e) => (d.days = e, ja(s, d)), n), p = f.I, ee = f.O, te = u - Number(ee - p), ne = 0;
	te && Math.sign(te) !== e ? n = p + BigInt(u) : (ne += e, u = vi(te, l, o), n = ee + BigInt(u));
	let re = Za(u);
	return [
		{
			...t,
			...re,
			days: t.days + ne
		},
		n,
		!!ne
	];
}
function Bi(e, t, n, r, i, a, o) {
	let s = qa(t), c = Wi(s, Ji(i, a), o), l = c - s, u = Math.sign(Number(c / w) - Number(s / w)) === e, d = Xa(c, Math.min(r, 6));
	return [
		{
			...t,
			...d
		},
		n + l,
		u
	];
}
function Vi(e) {
	let { timeZone: t } = e, n = M(L(e), er), r = M(da(n, 1), er);
	return [Qi(t, n), Qi(t, r)];
}
function Hi(e, t, n, r) {
	return yi(Ti(e < n ? e : n - 1n, t, n), r) ? n : t;
}
function Ui(e) {
	return vi(e, vn, 7);
}
function Wi(e, t, n) {
	return Ki(e, t, n, e / t % 2n);
}
function Gi(e, t, n) {
	let [r, i] = Gt(e, w), a = r * w;
	return a + Ki(i, t, n, (a / t + i / t) % 2n);
}
function Ki(e, t, n, r) {
	let i = e / t, a = e % t, o = 0;
	a && (o = Zt(S(2n * (a < 0n ? -a : a), t), Math.sign(Number(a))));
	let s = yi(Number(r) + o, n);
	return (i - r + BigInt(s)) * t;
}
function qi(e, t) {
	return C[e] * t;
}
function Ji(e, t) {
	return BigInt(C[e]) * BigInt(t);
}
var L = /*@__PURE__*/ Et(Yi, WeakMap);
function Yi(e) {
	let { epochNanoseconds: t, timeZone: n } = e, r = n.B(t);
	return {
		..._r(t + BigInt(r)),
		offsetNanoseconds: r
	};
}
function Xi(e, t, n, r = 0, i = 0, a, o) {
	if (n !== void 0 && r === 1 && (r === 1 || o)) return _i(t, n);
	r !== 2 && r !== 0 || N(t, 0);
	let s = e.R(t);
	if (n !== void 0 && r !== 3) {
		let e = ((e, t, n, r) => {
			let i = D(t);
			r && (n = Ui(n));
			for (let t of e) {
				let e = Number(i - t);
				if (r && (e = Ui(e)), e === n) return t;
			}
		})(s, t, n, a);
		if (e !== void 0) return e;
		r === 0 && _("Invalid TimeZone offset");
	}
	return o ? D(t) : Zi(e, t, i, s);
}
function Zi(e, t, n = 0, r = e.R(t)) {
	if (r.length === 1) return r[0];
	if (n === 1 && _("Ambiguous offset"), r.length) return r[+(n === 3)];
	let i = D(t), a = ((e, t) => {
		let n = e.B(t - w);
		return ((e) => (e > 864e11 && _("Out-of-bounds TimeZone gap"), e))(e.B(t + w) - n);
	})(e, i), o = _r(i + BigInt(a * (n === 2 ? -1 : 1)));
	return (r = e.R(o))[n === 2 ? 0 : r.length - 1];
}
function Qi(e, t) {
	let n = e.R(t);
	if (n.length) return n[0];
	let r = D(t) - w;
	return e.C(r, 1);
}
function $i(e, t, n, r = 0) {
	return Ua(n) && $a(n) < 8 && _("Cannot use small units"), aa(e, ia(e, N(aa(e, t)), n, r));
}
function ea(e, t, n = 0) {
	let { calendar: r, epochNanoseconds: i, timeZone: a } = e, o = Ja(t), s = i;
	if (Qa(t)) {
		let i = L(e);
		s = Zi(a, M(ia(r, i, {
			...t,
			...ei
		}, n), i)) + o;
	} else s += o;
	return {
		...e,
		epochNanoseconds: gi(s)
	};
}
function ta(e, t, n, r = 0) {
	let [i, a] = na(t, n);
	return mi(M(ia(e, t, {
		...n,
		...ei,
		days: n.days + a
	}, r), i));
}
function na(e, t) {
	return la(e, Ja(t));
}
function ra(e, t) {
	return ua(e, (Qa(n = t) && _("Cannot use large units"), Ja(n)));
	var n;
}
function ia(e, t, n, r = 0) {
	let { years: i, months: a, weeks: o, days: s } = n, c;
	if (s += Number(Ja(n) / w), i || a) c = oa(e, t, i, a, r);
	else {
		if (!o && !s) return t;
		c = t;
	}
	return (o || s) && (c = da(c, 7 * o + s)), N(c);
}
function aa(e, t) {
	return da(t, 1 - O(e, t).day);
}
function oa(e, t, n, r, i) {
	let { year: a, month: o, day: s } = O(e, t);
	if (n) {
		let [t, r] = Ir(e, a, o);
		a += n, o = ca(e, t, r, e ? e.p(a) : void 0, i), o = Tt("month", o, 1, zr(e, a), i);
	}
	if (r) {
		let t = sa(e, a, o, r);
		({year: a, month: o} = t);
	}
	return s = Tt("day", s, 1, Br(e, a, o), i), Rr(e, a, o, s);
}
function sa(e, t, n, r) {
	return e ? e.ae(t, n, r) : Tr(t, n, r);
}
function ca(e, t, n, r, i) {
	if (n) {
		let n = e ? e.l : void 0;
		return r !== void 0 && (n < 0 || r === t + 1) ? r : (i === 1 && _(_t), n < 0 ? -n : t);
	}
	return fn(t, 0, r);
}
function la(e, t) {
	let n = Number(t / w), r = Number(t % w), [i, a] = sr(E(e) + r);
	return [i, n + a];
}
function ua(e, t) {
	return gi(e + t);
}
function da(e, t) {
	return t ? vr(hr(e) + t) : e;
}
function fa(e, t) {
	return cn(e) !== cn(t) && _("Mismatching Calendars"), e;
}
function pa(e, t) {
	return e.m !== t.m && _("Mismatching TimeZones"), e;
}
function ma(e) {
	return e.timeZone.id;
}
function ha(e, t, n, r, i, a, o) {
	return r < 6 ? xa(t.epochNanoseconds, n.epochNanoseconds, r, i, a, o) : ((e, t, n, r, i, a, o) => {
		let s = n.epochNanoseconds;
		if (s === t.epochNanoseconds) return A;
		let c, l = pa(t.timeZone, n.timeZone);
		return c = Sa(l, e, t, n, r), c = Mi(c, s, r, i, a, o, Ma(e, l, t), 1), c;
	})(e, t, n, r, i, a, o);
}
function ga(e, t, n, r, i, a, o) {
	return r <= 6 ? xa(D(t), D(n), r, i, a, o) : ((e, t, n, r, i, a, o) => {
		let s = D(n), c = S(s, D(t));
		if (!c) return A;
		let l;
		return l = wa(e, t, n, c, r), l = Mi(l, s, r, i, a, o, ((e, t) => ({
			ne: D(t),
			ke: (n) => D(M(ia(e, t, n), t))
		}))(e, t)), l;
	})(e, t, n, r, i, a, o);
}
function _a(e, t, n, r, i, a, o) {
	let s = aa(e, t), c = aa(e, n);
	return Da(s, c) ? ba(e, N(s), N(c), r, i, a, o, 8) : A;
}
function va(e, t, n, r, i, a, o, s = 6) {
	return r === 6 ? xa(pr(t), pr(n), r, i, a, o) : ba(e, t, n, r, i, a, o, s);
}
function ya(e, t, n, r, i, a) {
	let o = vi(E(t) - E(e), qi(r, i), a);
	return {
		...A,
		...Za(o, n)
	};
}
function ba(e, t, n, r, i, a, o, s = 6) {
	let c = pr(n);
	if (!Da(t, n)) return A;
	let l;
	return l = Ea(e, t, n, r), i === s && a === 1 || (l = Mi(l, c, r, i, a, o, Na(e, t))), l;
}
function xa(e, t, n, r, i, a) {
	return {
		...A,
		...Xa(Wi(t - e, Ji(r, i), a), n)
	};
}
function Sa(e, t, n, r, i) {
	return i < 6 ? {
		...A,
		...Xa(r.epochNanoseconds - n.epochNanoseconds, i)
	} : ((e, n, r) => {
		let a = S(r.epochNanoseconds, n.epochNanoseconds);
		if (!a) return A;
		if (!Da(L(n), L(r))) return {
			...A,
			...Xa(r.epochNanoseconds - n.epochNanoseconds, 5)
		};
		let [o, s, c] = Ta(e, n, r, a);
		return {
			...(l = o, u = s, Ea(t, l, u, i)),
			...Za(c)
		};
		var l, u;
	})(e, n, r);
}
function Ca(e, t, n, r) {
	let i = D(t), a = D(n), o = S(a, i);
	return o ? r <= 6 ? {
		...A,
		...Xa(a - i, r)
	} : wa(e, t, n, o, r) : A;
}
function wa(e, t, n, r, i) {
	let a = n, o = E(n) - E(t);
	return Math.sign(o) === -r && (a = da(n, -r), o += 864e11 * r), {
		...Ea(e, t, a, i),
		...Za(o)
	};
}
function Ta(e, t, n, r) {
	let i = L(t), a = L(n), o = n.epochNanoseconds, s = 0, c = E(a) - E(i);
	Math.sign(c) === -r && s++;
	let l = s + +(r > 0);
	for (;; s++) {
		let t = da(a, s * -r), n = Zi(e, M(t, i));
		if (s === l || S(o, n) !== -r) return [
			i,
			t,
			Number(o - n)
		];
	}
}
function Ea(e, t, n, r) {
	if (r <= 7) return ((e, t, n) => {
		let r = Oa(t, n);
		return e ? {
			...A,
			weeks: Jt(r, 7),
			days: Yt(r, 7)
		} : {
			...A,
			days: r
		};
	})(r === 7, t, n);
	let i = O(e, t), a = O(e, n);
	if (r === 8) {
		let { year: r, month: o, day: s } = i, { year: c, month: l, day: u } = a, d = Math.sign(Ut(c, r) || Ut(l, o) || Oa(t, n)), f = 0, p = 0;
		if (d) {
			f = e ? e.ee(r, o, c, l) : Er(r, o, c, l);
			let i = oa(e, t, 0, f, 0);
			d * Ut(s, u) > 0 && (f -= d, i = oa(e, t, 0, f, 0)), p = Oa(i, n);
		}
		return {
			...A,
			months: f,
			days: p
		};
	}
	let { year: o, month: s, day: c } = i, { year: l, month: u, day: d } = a, f = l - o, p = u - s, ee = d - c;
	if (f || p) {
		let t = Math.sign(f || p), n = Br(e, l, u), r = 0;
		if (Math.sign(d - c) === -t) {
			let i = n, a = sa(e, l, u, -t);
			({year: l, month: u} = a), f = l - o, p = u - s, n = Br(e, l, u), r = t < 0 ? -i : n;
		}
		if (ee = d - Math.min(c, n) + r, f) {
			let [n, r] = Ir(e, o, s), [i, a] = Ir(e, l, u), c = e ? e.l : void 0;
			if (p = c !== void 0 && r && !a && (c < 0 ? t > 0 && i === -c : t < 0 && i === n) ? 0 : i - n || Number(a) - Number(r), Math.sign(p) === -t) {
				let i = t < 0 && -zr(e, l);
				l -= t, f = l - o, p = u - ca(e, n, r, e ? e.p(l) : void 0, 0) + (i || zr(e, l));
			} else if (e) {
				let t = ca(e, n, r, e.p(l), 0);
				p = e.ee(l, t, l, u);
			}
		}
	}
	return {
		...A,
		years: f,
		months: p,
		days: ee
	};
}
function Da(e, t) {
	return Ut(e.year, t.year) || Ut(e.month, t.month) || Ut(e.day, t.day);
}
function Oa(e, t) {
	return hr(t) - hr(e);
}
function ka(e, t, n) {
	return Pa(e) ? ((e, t, n) => {
		let { calendar: r, timeZone: i } = e, a = ea(e, t);
		return [
			Sa(i, r, e, a, n),
			a.epochNanoseconds,
			Ma(r, i, e)
		];
	})(e, t, n) : ((e, t, n) => {
		let { calendar: r } = e, i = mi(M(e, er)), a = ta(r, i, t);
		return [
			Ca(r, i, a, n),
			D(a),
			Na(r, e)
		];
	})(e, t, n);
}
function Aa(e, t) {
	return Pa(e) ? ea(e, t).epochNanoseconds : D(ta(e.calendar, M(e, er), t));
}
function ja(e, t) {
	return Qa(t) ? e.ke(t) : e.ne;
}
function Ma(e, t, n) {
	let r = L(n);
	return {
		ne: n.epochNanoseconds,
		ke: (n) => Zi(t, M(ia(e, r, n), r))
	};
}
function Na(e, t) {
	return {
		ne: pr(t),
		ke: (n) => pr(ia(e, t, n))
	};
}
function Pa(e) {
	return "timeZone" in e;
}
function Fa(e, t) {
	return e <= 6 - !!t;
}
function Ia(e, t, n) {
	let r = {};
	for (let i = t; i >= 0; i--) {
		let t = C[i];
		r[n[i]] = Jt(e, t), e = Yt(e, t);
	}
	return r;
}
var La = 2 ** 53;
function Ra(e, t, n) {
	let r = Math.max($a(t), $a(n));
	return r > 6 && _("Cannot use large units"), ((e, t, n, r) => Oi(Wa(((e, t, n, r) => {
		let i = qa(e) + qa(t) * BigInt(r ? -1 : 1);
		return Number.isFinite(Number(i / w)) || _("Out-of-bounds date"), {
			...A,
			...Xa(i, n)
		};
	})(t, n, r, e))))(e, t, n, r);
}
function za(e, t, n) {
	let r = $a(t), [i, a, o, s, c] = Ze(n, r, e);
	if (!c && Math.max(r, i) <= 6) return Oi(Wa(((e, t, n, r, i) => {
		let a = Wi(qa(e), Ji(n, r), i);
		return {
			...A,
			...Xa(a, t)
		};
	})(t, i, a, o, s)));
	c || _("Missing relativeTo");
	let l = Pa(c);
	if (!t.sign && (!l || i < 6)) return t;
	let [u, d, f] = ka(c, t, i);
	return Oi(Mi(u, d, i, a, o, s, f, l));
}
function Ba(e) {
	return e.sign === -1 ? Va(e) : e;
}
function Va(e) {
	return Oi(Ha(e));
}
function Ha(e) {
	let t = {};
	for (let n of k) t[n] = -1 * e[n] || 0;
	return t;
}
function Ua(e, t = k) {
	let n = 0;
	for (let r of t) {
		let t = Math.sign(e[r]);
		t && (n && n !== t && _("Cannot mix duration signs"), n = t);
	}
	return n;
}
function Wa(e) {
	for (let t of $r) Ga(t, e[t]);
	let t = qa(e);
	return Ka(Number(t / Cn)), e;
}
function Ga(e, t) {
	return Tt(e, t, -4294967295, 4294967295, 1);
}
function Ka(e) {
	Number.isSafeInteger(e) || _("Out-of-bounds duration");
}
function qa(e) {
	return BigInt(e.days) * w + Ja(e);
}
function Ja(e) {
	return BigInt(e.hours) * Tn + BigInt(e.minutes) * wn + Ya(e);
}
function Ya(e) {
	return BigInt(e.seconds) * Cn + BigInt(e.milliseconds) * Sn + BigInt(e.microseconds) * xn + BigInt(e.nanoseconds);
}
function Xa(e, t = 6) {
	let n = Number(e / w), r = Number(e % w), i = C[t], a = t <= 3 ? Number(e / BigInt(i)) : bn / i * n + Jt(r, i);
	Number.isFinite(a) || _("Out-of-bounds date"), t <= 3 && Math.abs(a) / (_n / C[t]) >= La && _("Out-of-bounds date");
	let o = Ia(r, t, k);
	return o[k[t]] = a, o;
}
function Za(e, t = 5) {
	return Ia(e, t, k);
}
function Qa(e) {
	return !!Ua(e, Qr);
}
function $a(e) {
	let t = 9;
	for (; t > 0 && !e[k[t]]; t--);
	return t;
}
function eo(e, t) {
	return S(e.epochNanoseconds, t.epochNanoseconds);
}
function to(e, t, n, r) {
	let i = e(me(r).relativeTo), a = Math.max($a(t), $a(n));
	return Pt(k, t, n) ? 0 : Fa(a, i && Pa(i)) ? S(qa(t), qa(n)) : (i || _("Missing relativeTo"), S(Aa(i, t), Aa(i, n)));
}
function no(e, t) {
	return ro(e, t) || io(e, t);
}
function ro(e, t) {
	return Ut(hr(e), hr(t));
}
function io(e, t) {
	return Ut(E(e), E(t));
}
function ao(e, t) {
	return !eo(e, t);
}
function oo(e, t) {
	return !eo(e, t) && e.timeZone.m === t.timeZone.m && e.calendar === t.calendar;
}
function so(e, t) {
	return !no(e, t) && e.calendar === t.calendar;
}
function co(e, t) {
	return !ro(e, t) && e.calendar === t.calendar;
}
function lo(e, t) {
	return !ro(e, t) && e.calendar === t.calendar;
}
function uo(e, t) {
	return !ro(e, t) && e.calendar === t.calendar;
}
function fo(e, t) {
	return !io(e, t);
}
function po(e) {
	return e === 0 ? on : e ? e.k : void 0;
}
function R(e, t, n = t) {
	return po(e) ? n : t;
}
function mo(e, t) {
	let n = t || void 0, r = po(t), { era: i, eraYear: a, year: o } = e;
	if (o !== void 0 && (o = m(o, "year")), a !== void 0 && (a = m(a, "eraYear")), i !== void 0 || a !== void 0) {
		i !== void 0 && a !== void 0 || v("Mismatching era/eraYear"), r || _("Forbidden era/eraYear");
		let e = sn(i), t = r[e];
		t === void 0 && _(((e) => `Invalid era: ${e}`)(i));
		let s = n?._ ? n._(a, e, t) : _o(a, t);
		o !== void 0 && o !== s && _("Mismatching year/eraYear"), o = s;
	} else o === void 0 && v(gt(r));
	return o;
}
function ho(e, t, n, r, i) {
	let { month: a, monthCode: o } = e;
	if (o !== void 0) {
		let e = ((e, t, n, r, i = un(t)) => {
			let a = e ? e.p(n) : void 0, [o, s] = i, c = fn(o, s, a);
			if (s) {
				let t = e ? e.l : void 0;
				t === void 0 && _(_t), t > 0 ? (c > t && _(_t), a !== c && (r === 1 && _(_t), c = fn(o, 0, a))) : (c !== -t && _(_t), a === void 0 && r === 1 && _(_t));
			}
			return c;
		})(t, o, n, i, r);
		a !== void 0 && a !== e && _("Mismatching month/monthCode"), a = e, i = 1;
	} else a === void 0 && v("Missing month/monthCode");
	return Tt("month", a, 1, zr(t, n), i);
}
function go(e, t, n, r, i) {
	return wt(e, "day", 1, Br(t, n, r), i);
}
function _o(e, t) {
	return (t + e) * (Math.sign(t) || 1) || 0;
}
function vo(e, t) {
	return rr(Nt(T, {
		...er,
		...e
	}), t);
}
var yo = /*@__PURE__*/ Rt("([+-])(\\d{2})(?::?(\\d{2})(?::?(\\d{2})(?:[.,](\\d{1,9}))?)?)?");
function bo(e) {
	let t = xo(e);
	return t === void 0 && _(xt(e)), t;
}
function xo(e, t) {
	let n = yo.exec(e);
	if (n && ((e) => ((e) => {
		e[0] !== "T" && e[0] !== "t" || (e = e.slice(1));
		let t = e.search(/[.,]/), n = t < 0 ? e : e.slice(0, t), r = n.split(":");
		return r.length === 1 ? /^(?:\d{2}|\d{4}|\d{6})$/i.test(n) : (r.length === 2 || r.length === 3) && r.every((e) => e.length === 2 && /^\d{2}$/i.test(e));
	})(e.slice(1)))(n[0])) return ((e, t) => {
		let n = e[4] || e[5];
		return t && n && _(St(n)), r = (Vt(e[2]) * yn + Vt(e[3]) * vn + Vt(e[4]) * _n + zt(e[5] || "")) * Bt(e[1]), Math.abs(r) >= 864e11 && _("Out-of-bounds offset"), r;
		var r;
	})(n, t);
}
var z = {
	era: ai,
	month: ge,
	monthCode(e, t) {
		return j(oi(e), t);
	},
	day: ge
}, So = /*@__PURE__*/ jt(T, m), Co = /*@__PURE__*/ jt(k, ci), wo = /*@__PURE__*/ Object.assign({}, z, So), To = {
	offset(e) {
		return bo(j(oi(e)));
	},
	...wo
};
function B(e, t, n, r, i = !r) {
	let a = {}, o = 0;
	for (let i of t) {
		let t = e[i];
		if (t !== void 0) {
			o = 1;
			let e = n[i];
			e && (t = e(t, i)), a[i] = t;
		} else r && r.includes(i) && v(dt(i));
	}
	return i && !o && v(ft(t)), a;
}
function V(e, t, n) {
	let r = po(t);
	e.year !== void 0 || e.era !== void 0 && e.eraYear !== void 0 || v(gt(r)), e.monthCode === void 0 && e.month === void 0 && v("Missing month/monthCode"), n || e.day !== void 0 || v(dt("day"));
	let i = No(e);
	return [mo(e, t), i];
}
function Eo(e, t) {
	let n = t === void 0, r = po(t);
	e.day === void 0 && v(dt("day")), n || e.month === void 0 || e.year !== void 0 || e.era !== void 0 && e.eraYear !== void 0 || v(gt(r));
	let i = No(e);
	return [e.eraYear !== void 0 || e.year !== void 0 ? mo(e, t) : void 0, i];
}
function Do(e, t = er, n) {
	let r = M(e, t);
	return mi(r), Ei(r, n);
}
function Oo(e, t, n, r, i) {
	let a = ho(e, t, n, r, i);
	return I(N(Rr(t, n, a, go(e, t, n, a, i))), t);
}
function ko(e, t, n, r, i) {
	return jo(t, n, ho(e, t, n, r, i));
}
function Ao(e, t, n, r, i) {
	let a = t === void 0, o = n, s, c, l;
	if (o === void 0 && a && (o = 1972), o !== void 0) {
		a || N(Rr(t, o, 1, 1));
		let n = ho(e, t, o, r, i);
		s = go(e, t, o, n, i), [c, l] = Ir(t, o, n);
	} else {
		e.monthCode === void 0 && v("Missing month/monthCode"), [c, l] = r;
		let n = t ? t.re : 1972;
		if (n !== void 0) s = go(e, t, n, ho(e, t, n, r, i), i);
		else {
			let n = i === 0 && t ? t.ge?.(c, l, e.day) : void 0;
			s = n === void 0 ? e.day : n;
		}
	}
	return Mo(t, c, l, s, e.day, i);
}
function jo(e, t, n) {
	return I(pi(Rr(e, t, n, 1)), e);
}
function Mo(e, t, n, r, i, a) {
	let o = n;
	o && ((e && e.V?.[t]) ?? 1 / 0) < i && (a === 1 && _(_t), o = 0, r = Ct(i, 1, (e && e.U) ?? 1 / 0));
	let s = e ? e.u(t, !!o, r) : br(t, !!o);
	for (; !s && a === 0 && r > 1;) r--, s = e ? e.u(t, !!o, r) : br(t, !!o);
	s || _("Cannot guess year");
	let { year: c, month: l } = s;
	return I(N(Rr(e, c, l, r)), e);
}
function No(e) {
	if (e.monthCode !== void 0) return un(e.monthCode);
}
var Po = Intl.DateTimeFormat;
function Fo(e, t) {
	t < -864e13 && _("Out-of-bounds date");
	let n = e.formatToParts(t), r = {};
	for (let e of n) r[e.type] = e.value;
	return r;
}
var Io = {
	El_Aaiun: 17,
	Tucuman: 12,
	Tirane: 11,
	Riga: 10,
	Simferopol: 9,
	Vienna: 9,
	Tunis: 8,
	Boa_Vista: 6,
	Fortaleza: 6,
	Maceio: 6,
	Noronha: 6,
	Recife: 6,
	Gaza: 6,
	Hebron: 6,
	DeNoronha: 6
}, Lo = -388152e4;
function Ro(e, t, n) {
	let [r, i, a, o] = st(n), s = r !== void 0;
	return ((e, t, n, r, i, a) => {
		n = Gi(n, BigInt(i), r);
		let o = t.B(n);
		return Xo(_r(n + BigInt(o)), a) + (e ? ts(Ui(o)) : "Z");
	})(s, H(s ? e(r) : "UTC"), t.epochNanoseconds, i, a, o);
}
function zo(e, t) {
	let n = ot(t);
	return ((e, t, n, r, i, a, o, s, c, l) => {
		r = Gi(r, BigInt(c), s);
		let u = n.B(r);
		return Xo(_r(r + BigInt(u)), l) + ts(Ui(u), o) + ns(t, a) + rs(e, i);
	})(e.calendar, e.timeZone.id, e.timeZone, e.epochNanoseconds, ...n);
}
function Bo(e, t) {
	let n = rt(t);
	return ((e, t, n, r, i, a) => Xo(Ii(t, i, r), a) + rs(e, n))(e.calendar, e, ...n);
}
function Vo(e, t) {
	return n = e.calendar, r = e, i = it(t), Zo(r) + rs(n, i);
	var n, r, i;
}
function Ho(e, t) {
	return Wo(e.calendar, Qo, e, it(t));
}
function Uo(e, t) {
	return Wo(e.calendar, $o, e, it(t));
}
function Wo(e, t, n, r) {
	return r === 1 ? e === void 0 ? t(n) : Zo(n) : r > 1 || r === 0 && e !== void 0 ? Zo(n) + is(cn(e), r === 2) : t(n);
}
function Go(e, t) {
	return ((e, t, n, r) => es(Li(e, n, t)[0], r))(e, ...at(t));
}
function Ko(e, t) {
	let [n, r, i] = at(t, 3);
	return r > 1 && Wa(e = {
		...e,
		...Ni(e, r, n)
	}), qo(e, i);
}
function qo(e, t) {
	let { sign: n } = e, r = n === -1 ? Ha(e) : e, { hours: i, minutes: a } = r, o = Ya(r), s = Number(o / Cn), c = Number(o % Cn);
	Ka(s);
	let l = os(c, t), u = t >= 0 || !n || l;
	return (n < 0 ? "-" : "") + "P" + Jo({
		Y: Yo(r.years),
		M: Yo(r.months),
		W: Yo(r.weeks),
		D: Yo(r.days)
	}) + (i || a || s || u ? "T" + Jo({
		H: Yo(i),
		M: Yo(a),
		S: Yo(s, u) + l
	}) : "");
}
function Jo(e) {
	let t = [];
	for (let n in e) {
		let r = e[n];
		r && t.push(r, n);
	}
	return t.join("");
}
function Yo(e, t) {
	if (!e && !t) return "";
	let n = Object.create(null);
	return n.useGrouping = 0, e.toLocaleString("fullwide", n);
}
function Xo(e, t) {
	return Zo(e) + "T" + es(e, t);
}
function Zo(e) {
	return Qo(e) + "-" + x(e.day);
}
function Qo(e) {
	let { year: t } = e;
	return (t < 0 || t > 9999 ? ss(t) + Ht(6, Math.abs(t)) : Ht(4, t)) + "-" + x(e.month);
}
function $o(e) {
	return x(e.month) + "-" + x(e.day);
}
function es(e, t) {
	let n = [x(e.hour), x(e.minute)];
	return t !== -1 && n.push(x(e.second) + ((e, t, n, r) => os(e * gn + t * hn + n, r))(e.millisecond, e.microsecond, e.nanosecond, t)), n.join(":");
}
function ts(e, t = 0) {
	if (t === 1) return "";
	let [n, r] = Kt(Math.abs(e), yn), [i, a] = Kt(r, vn), [o, s] = Kt(a, _n);
	return ss(e) + x(n) + ":" + x(i) + (o || s ? ":" + x(o) + os(s) : "");
}
function ns(e, t) {
	return t === 1 ? "" : "[" + (t === 2 ? "!" : "") + e + "]";
}
function rs(e, t) {
	return t > 1 || t === 0 && e !== void 0 ? is(cn(e), t === 2) : "";
}
function is(e, t) {
	return "[" + (t ? "!" : "") + "u-ca=" + e + "]";
}
var as = /0+$/;
function os(e, t) {
	let n = Ht(9, e);
	return n = t === void 0 ? n.replace(as, "") : n.slice(0, t), n ? "." + n : "";
}
function ss(e) {
	return e < 0 ? "-" : "+";
}
var cs = /^(AC|AE|AG|AR|AS|BE|BS|CA|CN|CS|CT|EA|EC|IE|IS|JS|MI|NE|NS|PL|PN|PR|PS|SS|VS)T$/, ls = /[^\w\/:+-]+/;
function us(e) {
	return ds(j(e));
}
function ds(e) {
	return fs(e).id;
}
function fs(e) {
	let t = e.toUpperCase(), n = ((e) => {
		let t = xo(e, 1);
		if (t !== void 0) return {
			id: ts(t),
			Z: t,
			m: t
		};
	})(t);
	return n ? {
		kind: "fixed",
		...n
	} : ps(t === "UTC" ? "UTC" : ((e) => (ls.test(e) && _(bt(e)), cs.test(e) && _("Forbidden ICU TimeZone"), e.toLowerCase().split("/").map((e, t) => (e.length <= 3 || /\d/.test(e)) && !/etc|yap/.test(e) ? e.toUpperCase() : e.replace(/baja|dumont|[a-z]+/g, (e, n) => e.length <= 2 && !t || e === "in" || e === "chat" ? e.toUpperCase() : e.length > 2 || !n ? Lt(e).replace(/island|noronha|murdo|rivadavia|urville/, Lt) : e)).join("/")))(e));
}
var ps = /*@__PURE__*/ Et((e) => {
	if (e === "UTC") return {
		kind: "utc",
		id: e,
		m: e
	};
	let t = ms(e.toUpperCase());
	return {
		kind: "named",
		id: e,
		format: t,
		m: t.resolvedOptions().timeZone
	};
}), ms = /*@__PURE__*/ Et((e) => new Po("en-u-hc-h23", {
	calendar: "iso8601",
	timeZone: e,
	era: "short",
	year: "numeric",
	month: "numeric",
	day: "numeric",
	hour: "numeric",
	minute: "numeric",
	second: "numeric"
}));
function H(e) {
	let t = fs(e);
	return hs(t.id, t);
}
var hs = /*@__PURE__*/ Et((e, t) => t.kind === "named" ? new _s(e, t.m, t.format) : new gs(e, t.m, t.kind === "fixed" ? t.Z : 0)), gs = class {
	constructor(e, t, n) {
		this.id = e, this.m = t, this.Z = n;
	}
	B() {
		return this.Z;
	}
	R(e) {
		return [_i(e, this.Z)];
	}
	C() {}
}, _s = class {
	constructor(e, t, n) {
		this.id = e, this.m = t, this.oe = ((e, t) => {
			let n = Et(e), r = Et(ys), i = 86400 * t;
			function a(e) {
				let [t, a] = bs(e, i), s = xs(t), c = xs(a), l = n(s), u = n(c);
				return l === u ? l : o(r(s, c), l, u, e);
			}
			function o(t, n, r, i) {
				let a, o;
				for (; (i === void 0 || (a = i < t[0] ? n : i >= t[1] ? r : void 0) === void 0) && (o = t[1] - t[0]);) {
					let n = t[0] + Math.floor(o / 2);
					e(n) === r ? t[1] = n : t[0] = n + 1;
				}
				return a;
			}
			return {
				Ae(e) {
					let t = a(e - 86400), n = a(e + 86400), r = e - t, i = e - n;
					if (t === n) return [r];
					let o = a(r);
					return o === a(i) ? [e - o] : t > n ? [r, i] : [];
				},
				ze: a,
				C: function e(t, a) {
					if (a > 0 && t >= 864e10) return;
					if (a < 0) {
						if (t <= Lo) return;
						let n = vs() + 94867200;
						if (t > n) return e(n, -1);
					}
					let [s, c] = bs(a > 0 ? Math.max(t, Lo) : t, i), l = i * a, u = a > 0 ? Math.max(t, vs()) + 94867200 : Lo, d = () => a < 0 ? c > u : s < u;
					for (; d();) {
						let e = xs(s), i = xs(c), u = n(e), d = n(i);
						if (u !== d) {
							let n = r(e, i);
							o(n, u, d);
							let s = n[0];
							if ((Ut(s, t) || 1) === a) return s;
						}
						s += l, c += l;
					}
				}
			};
		})(((e) => (t) => {
			let n = Fo(e, 1e3 * t);
			return 86400 * gr(((e) => {
				let t = e.relatedYear;
				if (t !== void 0) return parseInt(t);
				let n = parseInt(e.year);
				return e.era !== void 0 && sn(e.era) === "bce" ? 1 - n : n;
			})(n), parseInt(n.month), parseInt(n.day)) + 3600 * parseInt(n.hour) + 60 * parseInt(n.minute) + parseInt(n.second) - t;
		})(n), ((e) => Io[e.split("/").pop()] || 60)(e));
	}
	B(e) {
		return this.oe.ze(((e) => ur(e)[0])(e)) * _n;
	}
	R(e) {
		let t = 86400 * hr(e) + ar(e), n = or(e);
		return this.oe.Ae(t).map((e) => gi(BigInt(e) * Cn + BigInt(n)));
	}
	C(e, t) {
		let [n, r] = ur(e), i = this.oe.C(n + (t > 0 || r ? 1 : 0), t);
		if (i !== void 0) return BigInt(i) * Cn;
	}
};
function vs() {
	return Math.floor(Date.now() / 1e3);
}
function ys(e, t) {
	return [e, t];
}
function bs(e, t) {
	let n = Math.floor(e / t) * t;
	return [n, n + t];
}
function xs(e) {
	return Ct(e, -1e10, 864e10);
}
function Ss(e, t, n) {
	let r = B(n, R(t, Xn, Zn), To, [], 0), i = r.timeZone !== void 0, [a, o] = V(r, t), s = Oo(r, t, a, o, 0);
	if (i) {
		let n = vo(r), i = H(e(r.timeZone));
		return {
			epochNanoseconds: Xi(i, M(s, n), r.offset),
			timeZone: i,
			calendar: t
		};
	}
	return s;
}
function Cs(e, t, n, r) {
	let i = B(n, R(t, Xn, Zn), To, Mn, 0), a = e(i.timeZone), [o, s] = V(i, t), [c, l, u] = et(r), d = Oo(i, t, o, s, c), f = vo(i, c), p = H(a);
	return F(Xi(p, M(d, f), i.offset, l, u), p, t);
}
function ws(e, t, n) {
	let r = B(t, R(e, Kn, qn), wo, [], 0), [i, a] = V(r, e), o = h(n);
	return Do(Oo(r, e, i, a, o), vo(r, o), e);
}
function Ts(e, t, n, r = []) {
	let i = B(t, R(e, Wn, Gn), z, r), [a, o] = V(i, e);
	return Oo(i, e, a, o, h(n));
}
function Es(e, t, n, r) {
	let i = B(t, R(e, zn, Bn), z, r), [a, o] = V(i, e, 1);
	return ko(i, e, a, o, h(n));
}
function Ds(e, t, n, r) {
	let i = B(n, R(e, Wn, Gn), z, kn, 0);
	t && i.month !== void 0 && i.monthCode === void 0 && i.year === void 0 && (i.year = 1972);
	let [a, o] = Eo(i, e);
	return Ao(i, e, a, o, h(r));
}
function Os(e, t) {
	return vo(B(e, Ln, So, [], 1), h(t));
}
function ks(e) {
	let t = B(e, Xr, Co);
	return Oi(Wa({
		...A,
		...t
	}));
}
function U(e) {
	_(xt(e));
}
function As(e) {
	let t = rc(e = j(oi(e))), n;
	return t || U(e), t.F ? n = 0 : t.offset ? n = bo(t.offset) : U(e), t.timeZoneId && xo(t.timeZoneId, 1), Mr(t), P(_i(t, n));
}
function js(e, t) {
	let n = rc(j(e));
	return n || U(e), n.timeZoneId ? Ks(n, t, void 0) : (n.F && U(e), Js(n, t));
}
function Ms(e, t, n) {
	let r = rc(j(e));
	return r && r.timeZoneId || U(e), Ks(r, t, n);
}
function Ns(e, t) {
	let n = rc(j(e));
	return n && !n.F || U(e), qs(n, t);
}
function Ps(e, t) {
	let n = Us(Hs(j(e)), void 0, t);
	return I(n, n.calendar);
}
function Fs(e, t) {
	let n = ic(j(e));
	if (n) return Is(n), I(pi(Nr(n)), t(n.calendarId));
	let r = Us(Hs(e), Ws, t), { calendar: i } = r;
	return I(aa(i, r), i);
}
function Is(e) {
	e.calendarId !== "iso8601" && _(St(e.calendarId));
}
function Ls(e, t) {
	let n = ac(j(e));
	if (n) return Is(n), I(Nr(n), t(n.calendarId));
	let r = Us(Hs(e), Gs, t), { calendar: i } = r, { year: a, month: o, day: s } = O(i, r), [c, l] = Ir(i, a, o), { year: u, month: d } = ((e, t, n, r) => {
		let i = e ? e.u(t, n, r) : br(t, n);
		return i || _("Cannot guess year"), i;
	})(i, c, l, s);
	return I(N(Rr(i, u, d, s)), i);
}
function Rs(e) {
	let t = ((e) => {
		let t = oc(e);
		return t ? (lc(t[13]), sc(t, 1)) : void 0;
	})(e = j(e));
	if (!t) {
		let n = rc(e);
		n && n.te || U(e), n.F && _(St("Z")), Is(n), t = n;
	}
	let n;
	return (n = ic(e)) && Pr(n) && U(e), (n = ac(e)) && Pr(n) && U(e), Di(tr(t));
}
function zs(e) {
	let t = nc.exec(j(e));
	return t || U(e), Oi(Wa(((e) => {
		let t = 0, n = 0, r = 0, i = {
			years: a(e[2]),
			months: a(e[3]),
			weeks: a(e[4]),
			days: a(e[5]),
			hours: a(e[6], e[7], 5),
			minutes: a(e[8], e[9], 4),
			seconds: a(e[10], e[11], 3),
			...Ia(r, 2, k)
		};
		return t || _(ft(k)), Bt(e[1]) < 0 && (i = Ha(i)), i;
		function a(e, i, a) {
			let o = 0, s = 0;
			return a && ([o, r] = Kt(r, C[a])), e !== void 0 && (n && _(St(e)), s = ((e) => {
				let t = parseInt(e);
				return Number.isFinite(t) || _(St(e)), t;
			})(e), t = 1, i && (r = zt(i) * (C[a] / _n), n = 1)), o + s;
		}
	})(t)));
}
function Bs(e) {
	let t = rc(e) || ic(e) || ac(e);
	if (t) return t.calendarId;
	let n = oc(e);
	return n ? lc(n[13]).calendarId : e;
}
function Vs(e) {
	let t = rc(e);
	return t && (t.timeZoneId || t.F && "UTC" || t.offset) || e;
}
function Hs(e) {
	let t = rc(e);
	return t && !t.F || U(e), t;
}
function Us(e, t, n) {
	return t && e.calendarId === "iso8601" ? (Nr(e), e.te && tr(e), Js(t(e), n)) : e.te ? qs(e, n) : Js(e, n);
}
function Ws(e) {
	let t = 12 * e.year + e.month === fi ? 20 : 1;
	return {
		...e,
		day: t
	};
}
function Gs(e) {
	return {
		...e,
		year: 1972
	};
}
function Ks(e, t, n) {
	let r = H(ds(e.timeZoneId)), i;
	if (Mr(e), e.te) {
		let t = e.offset ? bo(e.offset) : void 0, [, o, s] = et(n);
		i = Xi(r, e, t, o, s, !(r.Z || e.offset === void 0 || (a = e.offset, a.replace(/\D/g, "").length > 4)), e.F);
	} else et(n), i = Qi(r, e);
	var a;
	return gi(i), F(i, r, t(e.calendarId));
}
function qs(e, t) {
	return Mr(e), mi(e), {
		...M(e, e),
		calendar: t(e.calendarId)
	};
}
function Js(e, t) {
	return Nr(e), N(e), {
		calendar: t(e.calendarId),
		year: e.year,
		month: e.month,
		day: e.day
	};
}
function Ys(e) {
	return `(\\d{2})(?:(:?)(\\d{2})(?:\\${e}(\\d{2})(?:[.,](\\d{1,9}))?)?)?`;
}
var Xs = "(?:(?:([+-])(\\d{6}))|(\\d{4}))(-?)(\\d{2})\\4(\\d{2})(?:[T ]" + Ys(8) + "(Z|([+-])" + Ys(15) + ")?)?", Zs = /*@__PURE__*/ Rt("(?:(?:([+-])(\\d{6}))|(\\d{4}))-?(\\d{2})((?:\\[(!?)([^\\]]*)\\]){0,9})"), Qs = /*@__PURE__*/ Rt("(?:--)?(\\d{2})-?(\\d{2})((?:\\[(!?)([^\\]]*)\\]){0,9})"), $s = /*@__PURE__*/ Rt(Xs + "((?:\\[(!?)([^\\]]*)\\]){0,9})"), ec = /*@__PURE__*/ Rt("T?" + Ys(2) + `(([+-])${Ys(9)})?((?:\\[(!?)([^\\]]*)\\]){0,9})`), tc = /*@__PURE__*/ RegExp("\\[(!?)([^\\]]*)\\]", "g"), nc = /*@__PURE__*/ Rt("([+-])?P(\\d+Y)?(\\d+M)?(\\d+W)?(\\d+D)?(?:T(?!$)(?:(\\d+)(?:[.,](\\d{1,9}))?H)?(?:(\\d+)(?:[.,](\\d{1,9}))?M)?(?:(\\d+)(?:[.,](\\d{1,9}))?S)?)?");
function rc(e) {
	let t = $s.exec(e);
	return t ? ((e) => {
		let t = e[12], n = (t || "").toUpperCase() === "Z";
		return {
			year: cc(e),
			month: parseInt(e[5]),
			day: parseInt(e[6]),
			...sc(e, 7),
			...lc(e[19]),
			te: !!e[7],
			F: n,
			offset: n ? void 0 : t
		};
	})(t) : void 0;
}
function ic(e) {
	let t = Zs.exec(e);
	if (t) return ((e) => ({
		year: cc(e),
		month: parseInt(e[4]),
		day: 1,
		...lc(e[5])
	}))(t);
}
function ac(e) {
	let t = Qs.exec(e);
	return t ? ((e) => ({
		year: 1972,
		month: parseInt(e[1]),
		day: parseInt(e[2]),
		...lc(e[3])
	}))(t) : void 0;
}
function oc(e) {
	let t = ec.exec(e);
	if (t) return t[6] && bo(t[6]), t;
}
function sc(e, t) {
	let n = Vt(e[t + 3]);
	return {
		...sr(zt(e[t + 4] || ""))[0],
		hour: Vt(e[t]),
		minute: Vt(e[t + 2]),
		second: n === 60 ? 59 : n
	};
}
function cc(e) {
	let t = Bt(e[1]), n = parseInt(e[2] || e[3]);
	return t < 0 && !n && _(St(-0)), t * n;
}
function lc(e) {
	let t, n, r = [];
	return e.replace(tc, (e, i, a) => {
		let o = !!i, [s, c] = a.split("=").reverse();
		return c ? c === "u-ca" ? (r.push(s.toLowerCase()), t ||= o) : (o || /[A-Z]/.test(c)) && _(St(e)) : (n && _(St(e)), n = s), "";
	}), r.length > 1 && t && _(St(e)), {
		timeZoneId: n,
		calendarId: r[0] || "iso8601"
	};
}
function uc(e, t, n) {
	let r = Object.assign(Object.create(null), t);
	return dc(r, n, Fn), po(e) && (dc(r, n, Pn), e && e.je && dc(r, n, In, Nn)), r;
}
function dc(e, t, n, r) {
	let i = 0, a = [];
	for (let e of n) t[e] === void 0 ? a.push(e) : i = 1;
	if (Object.assign(e, t), i) for (let t of r || a) delete e[t];
}
function fc(e, t, n) {
	let r = R(e, Jn, Yn), i = L(t), { year: a, month: o, day: s } = O(e, i), c = {
		year: a,
		monthCode: xc(e, a, o),
		day: s,
		hour: i.hour,
		minute: i.minute,
		second: i.second,
		millisecond: i.millisecond,
		microsecond: i.microsecond,
		nanosecond: i.nanosecond,
		offset: i.offsetNanoseconds
	}, l = B(n, r, To), u = uc(e, c, l);
	return [{
		...c,
		...l
	}, u];
}
function pc(e, t, n) {
	let r = R(e, Kn, qn), { year: i, month: a, day: o } = O(e, t), s = {
		year: i,
		monthCode: xc(e, i, a),
		day: o,
		hour: t.hour,
		minute: t.minute,
		second: t.second,
		millisecond: t.millisecond,
		microsecond: t.microsecond,
		nanosecond: t.nanosecond
	}, c = B(n, r, wo), l = uc(e, s, c);
	return [{
		...s,
		...c
	}, l];
}
function mc(e, t, n) {
	let r = R(e, Wn, Gn), { year: i, month: a, day: o } = O(e, t);
	return uc(e, {
		year: i,
		monthCode: xc(e, i, a),
		day: o
	}, B(n, r, z));
}
function hc(e, t, n) {
	let r = R(e, zn, Bn), { year: i, month: a } = O(e, t);
	return uc(e, {
		year: i,
		monthCode: xc(e, i, a)
	}, B(n, r, z));
}
function gc(e, t, n) {
	let r = R(e, Wn, Gn), { year: i, month: a, day: o } = O(e, t);
	return uc(e, {
		monthCode: xc(e, i, a),
		day: o
	}, B(n, r, z));
}
function _c(e, t, n, r, i, a, o, s) {
	let { calendar: c, timeZone: l } = e;
	return F(Xi(l, M(Oo(n, c, r, i, a), rr(t, a)), t.offset, o, s), l, c);
}
function vc(e, t, n, r, i, a) {
	return Do(Oo(t, n, r, i, a), rr(e, a), n);
}
function yc(e, t) {
	return {
		...Nt(Ln, e),
		...B(t, Ln, So)
	};
}
function bc(e, t) {
	return Oi((n = e, r = t, Wa({
		...n,
		...B(r, Xr, Co)
	})));
	var n, r;
}
function xc(e, t, n) {
	let [r, i] = Ir(e, t, n);
	return dn(r, i);
}
function Sc(e, t, n) {
	let [r, i] = $e(n, e), a = $a(t), o = Math.max(r, a), s = i && Pa(i);
	if (!i && Fa(o, s)) return Cc(t, r);
	if (i || _("Missing relativeTo"), !t.sign && (!s || r < 6)) return 0;
	let [c, l, u] = ka(i, t, r);
	return Fa(r, s) ? Cc(c, r) : ((e, t, n, r) => {
		let i = k[n], a = ti(n, e);
		return bi(e[i], Ua(e) || 1, t, (e) => (a[i] = e, ja(r, a)));
	})(c, l, r, u);
}
function Cc(e, t) {
	return En(qa(e), C[t]);
}
function wc(e, t, n) {
	return F(e.epochNanoseconds, t, n);
}
function Tc(e) {
	return P(e.epochNanoseconds);
}
function Ec(e) {
	return Ei(L(e), e.calendar);
}
function Dc(e) {
	return I(L(e), e.calendar);
}
function Oc(e) {
	return Di(L(e));
}
function kc(e, t, n) {
	return F(gi(Zi(t, e, n)), t, e.calendar);
}
function Ac(e, t, n) {
	let r;
	return r = n ? Zi(t, M(e, n)) : Qi(t, M(e, er)), F(r, t, e.calendar);
}
function jc(e, t, n) {
	return Fc(e, Nt(R(e, Vn, Hn), t), B(be(n), kn, z, []));
}
function Mc(e, t, n) {
	let r = R(e, On, Rn);
	return Fc(e, Nt(Un, t), B(be(n), r, z, []));
}
function Nc(e, t) {
	let n = B(t, Un, z), [r, i] = Eo(n, e);
	return Ao(n, e, r, i, 0);
}
function Pc(e, t) {
	let n = B(t, R(e, Vn, Hn), z), [r, i] = V(n, e, 1);
	return ko(n, e, r, i, 0);
}
function Fc(e, t, n) {
	let r = R(e, Qn, $n), i = uc(e, t, n);
	i = B(i, r, z, []);
	let [a, o] = V(i, e);
	return Oo(i, e, a, o, 0);
}
function Ic(e) {
	return P(gi(BigInt(ci(e)) * Sn));
}
function Lc(e) {
	return P(gi(si(e)));
}
function Rc(e) {
	return e.timeZone = "UTC", ["full", "long"].includes(e.timeStyle) && (e.timeStyle = "medium"), e;
}
function zc(e, t) {
	return e.timeZone !== void 0 && v("Cannot specify TimeZone"), e.timeZone = t, e;
}
function Bc(e, t, n) {
	let r = e.resolvedOptions().calendar;
	!n && t.calendar === void 0 || cn(t.calendar) === r || _("Mismatching Calendars");
}
function Vc(e, t, n, r, i) {
	let a = new Set(e), o = new Set(t), s = new Set(n);
	return (e, t) => {
		let n, c, l = {}, u = {}, d = {}, f = 0, p = 0;
		for (let t of Object.keys(e)) {
			let r = e[t];
			r === void 0 || s.has(t) || (a.has(t) ? t === "dateStyle" ? n = r : t === "timeStyle" ? c = r : l[t] = r : t === "era" ? u[t] = r : o.has(t) ? t === "dateStyle" || t === "timeStyle" ? p = 1 : f = 1 : d[t] = r);
		}
		let ee = n !== void 0, te = c !== void 0, ne = ee || te, re = Object.keys(l).length > 0, ie = f || p, ae = re || ee || te, oe = Object.keys(u).length > 0;
		(!t && ie || t && ie && !ae || ne && (re || oe || f)) && v("Invalid formatting options");
		let se = {};
		return ne || ae || Object.assign(se, r), Object.assign(se, l, u, d), ee && (i ? Object.assign(se, i[n]) : se.dateStyle = n), te && (se.timeStyle = c), se;
	};
}
var Hc = {
	year: "numeric",
	month: "numeric",
	day: "numeric"
}, Uc = {
	hour: "numeric",
	minute: "numeric",
	second: "numeric"
}, Wc = /*@__PURE__*/ Object.assign({}, Hc, Uc), Gc = [
	"weekday",
	"year",
	"month",
	"day",
	"dateStyle"
], Kc = [
	"dayPeriod",
	"hour",
	"minute",
	"second",
	"fractionalSecondDigits",
	"timeStyle"
], qc = /*@__PURE__*/ Gc.concat(Kc), Jc = /*@__PURE__*/ ["weekday", "day"].concat(Kc), Yc = /*@__PURE__*/ ["weekday", "year"].concat(Kc), Xc = /*@__PURE__*/ Vc(qc, [], [], Wc), Zc = /*@__PURE__*/ Vc(qc, [], [], {
	...Wc,
	timeZoneName: "short"
}), Qc = /*@__PURE__*/ Vc(qc, [], ["timeZoneName"], Wc), $c = /*@__PURE__*/ Vc(Gc, Kc, ["timeZoneName"], Hc), el = /*@__PURE__*/ Vc(Kc, Gc, ["timeZoneName", "era"], Uc), tl = /*@__PURE__*/ Vc([
	"year",
	"month",
	"dateStyle"
], Jc, ["timeZoneName"], {
	year: "numeric",
	month: "numeric"
}, {
	full: {
		year: "numeric",
		month: "long"
	},
	long: {
		year: "numeric",
		month: "long"
	},
	medium: {
		year: "numeric",
		month: "short"
	},
	short: {
		year: "2-digit",
		month: "numeric"
	}
}), nl = /*@__PURE__*/ Vc([
	"month",
	"day",
	"dateStyle"
], Yc, ["timeZoneName", "era"], {
	month: "numeric",
	day: "numeric"
}, {
	full: {
		month: "long",
		day: "numeric"
	},
	long: {
		month: "long",
		day: "numeric"
	},
	medium: {
		month: "short",
		day: "numeric"
	},
	short: {
		month: "numeric",
		day: "numeric"
	}
});
function rl(e, t) {
	let { timeZone: n } = e, r = L(e), { offsetNanoseconds: i } = r, a = t || er, o;
	return o = t ? Xi(n, M(r, a), i, 2) : Qi(n, M(r, a)), F(o, n, e.calendar);
}
function il(e) {
	let t = al(), n = e.B(t);
	return _r(t + BigInt(n));
}
function al() {
	return BigInt(Date.now()) * Sn;
}
function ol() {
	return new Po().resolvedOptions().timeZone;
}
//#endregion
//#region ../../node_modules/temporal-polyfill/chunks/apiHelpers.js
var sl = "PlainYearMonth", cl = "PlainMonthDay", ll = "PlainDate", ul = "PlainDateTime", dl = "PlainTime", fl = "ZonedDateTime", pl = "Instant", ml = "Duration";
function hl(e, t, n, ...r) {
	return Object.defineProperties(t, Dt(e)), Object.defineProperties(t.prototype, kt("Temporal." + e)), Object.defineProperties(t.prototype, At((e) => ({
		get() {
			return e(n(this));
		},
		configurable: 1
	}), Object.assign({}, ...r))), t;
}
var gl = It.name === "noop" ? (e) => {
	Object.defineProperty(e, "_str_", { value: e.toJSON() });
} : It;
function _l() {
	v(ht);
}
function vl() {
	v(mt);
}
var yl = {
	era(e) {
		return Lr(e.calendar, e).era;
	},
	eraYear(e) {
		return Lr(e.calendar, e).eraYear;
	},
	year(e) {
		return O(e.calendar, e).year;
	},
	month(e) {
		return O(e.calendar, e).month;
	},
	monthCode(e) {
		return Vr(e.calendar, e);
	}
}, bl = {
	era(e) {
		return Lr(e.calendar, e).era;
	},
	eraYear(e) {
		return Lr(e.calendar, e).eraYear;
	},
	year(e) {
		return O(e.calendar, e).year;
	},
	month(e) {
		return O(e.calendar, e).month;
	},
	monthCode(e) {
		return Vr(e.calendar, e);
	},
	day(e) {
		return O(e.calendar, e).day;
	}
}, xl = {
	monthCode(e) {
		return Vr(e.calendar, e);
	},
	day(e) {
		return O(e.calendar, e).day;
	}
}, Sl = {
	daysInMonth(e) {
		return Wr(e.calendar, e);
	},
	daysInYear(e) {
		return Gr(e.calendar, e);
	},
	monthsInYear(e) {
		return Ur(e.calendar, e);
	},
	inLeapYear(e) {
		return Hr(e.calendar, e);
	}
}, Cl = {
	dayOfWeek(e) {
		return Dr(e);
	},
	dayOfYear(e) {
		return Kr(e.calendar, e);
	},
	weekOfYear(e) {
		return qr(e.calendar, e);
	},
	yearOfWeek(e) {
		return Jr(e.calendar, e);
	},
	daysInWeek() {
		return 7;
	},
	daysInMonth(e) {
		return Wr(e.calendar, e);
	},
	daysInYear(e) {
		return Gr(e.calendar, e);
	},
	monthsInYear(e) {
		return Ur(e.calendar, e);
	},
	inLeapYear(e) {
		return Hr(e.calendar, e);
	}
};
function wl(e, t, n, r) {
	let [i, a, o, s] = Xe(e, r, 3, 5);
	return Al(e, xa(t.epochNanoseconds, n.epochNanoseconds, i, a, o, s));
}
function Tl(e, t, n, r) {
	let i = fa(t.calendar, n.calendar), [a, o, s, c] = Xe(e, r, 5);
	return Al(e, ha(i, t, n, a, o, s, c));
}
function El(e, t, n, r) {
	let i = fa(t.calendar, n.calendar), [a, o, s, c] = Xe(e, r, 6);
	return Al(e, ga(i, t, n, a, o, s, c));
}
function Dl(e, t, n, r) {
	let i = fa(t.calendar, n.calendar), [a, o, s, c] = Xe(e, r, 6, 9, 6);
	return Al(e, va(i, t, n, a, o, s, c));
}
function Ol(e, t, n, r) {
	let i = fa(t.calendar, n.calendar), [a, o, s, c] = Xe(e, r, 9, 9, 8);
	return Al(e, _a(i, t, n, a, o, s, c));
}
function kl(e, t, n, r) {
	let [i, a, o, s] = Xe(e, r, 5, 5);
	return Al(e, ya(t, n, i, a, o, s));
}
function Al(e, t) {
	return Oi(e ? Ha(t) : t);
}
function jl(e, t, n) {
	let { calendar: r } = e, i = mc(r, e, t), [a, o] = V(i, r);
	return Oo(i, r, a, o, h(n));
}
function Ml(e, t, n) {
	let { calendar: r } = e, [i, a] = pc(r, e, t), [o, s] = V(a, r);
	return vc(i, a, r, o, s, h(n));
}
function Nl(e, t, n) {
	let { calendar: r } = e, i = hc(r, e, t), [a, o] = V(i, r, 1);
	return ko(i, r, a, o, h(n));
}
function Pl(e, t, n) {
	let { calendar: r } = e, i = gc(r, e, t), [a, o] = Eo(i, r);
	return Ao(i, r, a, o, h(n));
}
function Fl(e, t, n) {
	return vo(yc(e, t), h(n));
}
function Il(e, t, n) {
	let { calendar: r } = e, [i, a] = fc(r, e, t), [o, s] = V(a, r), [c, l, u] = et(n, 2);
	return _c(e, i, a, o, s, c, l, u);
}
//#endregion
//#region ../../node_modules/temporal-polyfill/chunks/classApi-basic.js
function Ll(e) {
	let t = j(e).toLowerCase();
	return t === "iso8601" ? void 0 : t === "gregory" ? 0 : void _(yt(e, "temporal-polyfill/full"));
}
function Rl(e = an) {
	return Ll(e);
}
var zl = /*@__PURE__*/ new WeakMap(), Bl = /*@__PURE__*/ hl(fl, class {
	constructor(e, t, n = void 0) {
		let r = gi(si(e)), i = H(us(t)), a = Rl(n);
		Wl(this, F(r, i, a));
	}
	static from(e, t = void 0) {
		return W(Ul(e, t));
	}
	static compare(e, t) {
		return eo(Ul(e), Ul(t));
	}
	get calendarId() {
		return cn(G(this).calendar);
	}
	get timeZoneId() {
		return G(this).timeZone.id;
	}
	get epochMilliseconds() {
		return dr(G(this).epochNanoseconds);
	}
	get epochNanoseconds() {
		return G(this).epochNanoseconds;
	}
	get offset() {
		return ts(L(G(this)).offsetNanoseconds);
	}
	get offsetNanoseconds() {
		return L(G(this)).offsetNanoseconds;
	}
	get hoursInDay() {
		return Ai(G(this));
	}
	with(e, t = void 0) {
		return W(Il(G(this), fu(e), t));
	}
	withCalendar(e) {
		return W({
			...G(this),
			calendar: Fu(e)
		});
	}
	withTimeZone(e) {
		return W({
			...G(this),
			timeZone: H(K(e))
		});
	}
	withPlainTime(e = void 0) {
		return W(rl(G(this), yu(e)));
	}
	add(e, t = void 0) {
		return W(ea(G(this), $(e), h(t)));
	}
	subtract(e, t = void 0) {
		return W(ea(G(this), Ha($(e)), h(t)));
	}
	until(e, t = void 0) {
		return Z(Tl(0, G(this), Ul(e), t));
	}
	since(e, t = void 0) {
		return Z(Tl(1, G(this), Ul(e), t));
	}
	round(e) {
		let t = G(this), [n, r, i] = Qe(e);
		return W(ki(t, n, r, i));
	}
	startOfDay() {
		return W(ji(G(this)));
	}
	equals(e) {
		return oo(G(this), Ul(e));
	}
	toInstant() {
		return ql(Tc(G(this)));
	}
	toPlainDateTime() {
		return Cu(Ec(G(this)));
	}
	toPlainDate() {
		return ku(Dc(G(this)));
	}
	toPlainTime() {
		return hu(Oc(G(this)));
	}
	toLocaleString(e = void 0, t = {}) {
		let n = G(this), r = new Po(e, zc(Zc(t), ma(n)));
		return Bc(r, n), r.format(dr(n.epochNanoseconds));
	}
	toString(e = void 0) {
		return zo(G(this), e);
	}
	toJSON() {
		return zo(G(this));
	}
	getTimeZoneTransition(e) {
		let t = G(this), n = t.timeZone.C(t.epochNanoseconds, lt(e));
		return n === void 0 ? null : W({
			...t,
			epochNanoseconds: n
		});
	}
	valueOf() {
		return vl();
	}
}, Vl, bl, Cl, Dn);
function W(e) {
	return Wl(Object.create(Bl.prototype), e);
}
function G(e) {
	return Hl(e) || _l();
}
function Vl(e) {
	let t = G(e);
	return {
		...L(t),
		calendar: t.calendar
	};
}
function Hl(e) {
	return zl.get(e);
}
function Ul(e, t) {
	if (g(e)) {
		let n = Hl(e);
		return n ? (et(t), n) : Cs(K, Nu(e), e, t);
	}
	return Ms(e, Ll, t);
}
function Wl(e, t) {
	return zl.set(e, t), gl(e), e;
}
function K(e) {
	if (g(e)) {
		let t = Hl(e);
		return t || v(bt(e)), t.timeZone.id;
	}
	return ((e) => ds(Vs(j(e))))(e);
}
var Gl = /*@__PURE__*/ new WeakMap(), Kl = /*@__PURE__*/ hl(pl, class {
	constructor(e) {
		let t = gi(si(e));
		Zl(this, P(t));
	}
	static from(e) {
		return ql(Yl(e));
	}
	static fromEpochMilliseconds(e) {
		return ql(Ic(e));
	}
	static fromEpochNanoseconds(e) {
		return ql(Lc(e));
	}
	static compare(e, t) {
		return eo(Yl(e), Yl(t));
	}
	get epochMilliseconds() {
		return dr(q(this).epochNanoseconds);
	}
	get epochNanoseconds() {
		return q(this).epochNanoseconds;
	}
	add(e) {
		return ql(P(ra(q(this).epochNanoseconds, $(e))));
	}
	subtract(e) {
		return ql(P(ra(q(this).epochNanoseconds, Ha($(e)))));
	}
	until(e, t = void 0) {
		return Z(wl(0, q(this), Yl(e), t));
	}
	since(e, t = void 0) {
		return Z(wl(1, q(this), Yl(e), t));
	}
	round(e) {
		let t = q(this), [n, r, i] = Qe(e, 5, 1);
		return ql(P(Gi(t.epochNanoseconds, Ji(n, r), i)));
	}
	equals(e) {
		return ao(q(this), Yl(e));
	}
	toZonedDateTimeISO(e) {
		return W(wc(q(this), H(K(e))));
	}
	toLocaleString(e = void 0, t = {}) {
		let n = q(this);
		return new Po(e, Xc(t)).format(dr(n.epochNanoseconds));
	}
	toString(e = void 0) {
		return Ro(K, q(this), e);
	}
	toJSON() {
		return Ro(K, q(this));
	}
	valueOf() {
		return vl();
	}
});
function ql(e) {
	return Zl(Object.create(Kl.prototype), e);
}
function q(e) {
	return Jl(e) || _l();
}
function Jl(e) {
	return Gl.get(e);
}
function Yl(e) {
	if (g(e)) {
		let t = Jl(e);
		if (t) return t;
		let n = Hl(e);
		if (n) return P(n.epochNanoseconds);
	}
	return As(e);
}
var { toTemporalInstant: Xl } = { toTemporalInstant() {
	let e = Date.prototype.valueOf.call(this);
	return ql(P(BigInt(ii(e)) * Sn));
} };
function Zl(e, t) {
	return Gl.set(e, t), gl(e), e;
}
var Ql = /*@__PURE__*/ new WeakMap(), $l = /*@__PURE__*/ hl(cl, class {
	constructor(e, t, n = void 0, r) {
		let i = m(e), a = m(t), o = Rl(n), s = N(Nr({
			year: m(r ?? 1972),
			month: i,
			day: a
		}));
		iu(this, I(s, o));
	}
	static from(e, t = void 0) {
		return eu(ru(e, t));
	}
	get calendarId() {
		return cn(tu(this).calendar);
	}
	with(e, t = void 0) {
		return eu(Pl(tu(this), fu(e), t));
	}
	equals(e) {
		return uo(tu(this), ru(e));
	}
	toPlainDate(e) {
		return ku(Mc(tu(this).calendar, this, e));
	}
	toLocaleString(e = void 0, t = {}) {
		let n = tu(this), r = new Po(e, Rc(nl(t)));
		return Bc(r, n, 1), r.format(mr(n));
	}
	toString(e = void 0) {
		return Uo(tu(this), e);
	}
	toJSON() {
		return Uo(tu(this));
	}
	valueOf() {
		return vl();
	}
}, tu, xl);
function eu(e) {
	return iu(Object.create($l.prototype), e);
}
function tu(e) {
	return nu(e) || _l();
}
function nu(e) {
	return Ql.get(e);
}
function ru(e, t) {
	if (g(e)) {
		let n = nu(e);
		if (n) return h(t), n;
		let r = Pu(e);
		return Ds(r === void 0 ? void 0 : r, r === void 0, e, t);
	}
	let n = Ls(e, Ll);
	return h(t), n;
}
function iu(e, t) {
	return Ql.set(e, t), gl(e), e;
}
var au = /*@__PURE__*/ new WeakMap(), ou = /*@__PURE__*/ hl(sl, class {
	constructor(e, t, n = void 0, r) {
		let i = m(e), a = m(t), o = Rl(n), s = pi(Nr({
			year: i,
			month: a,
			day: m(r ?? 1)
		}));
		uu(this, I(s, o));
	}
	static from(e, t = void 0) {
		return su(lu(e, t));
	}
	static compare(e, t) {
		return ro(lu(e), lu(t));
	}
	get calendarId() {
		return cn(J(this).calendar);
	}
	with(e, t = void 0) {
		return su(Nl(J(this), fu(e), t));
	}
	add(e, t = void 0) {
		let n = J(this);
		return su(I($i(n.calendar, n, $(e), h(t)), n.calendar));
	}
	subtract(e, t = void 0) {
		let n = J(this);
		return su(I($i(n.calendar, n, Ha($(e)), h(t)), n.calendar));
	}
	until(e, t = void 0) {
		return Z(Ol(0, J(this), lu(e), t));
	}
	since(e, t = void 0) {
		return Z(Ol(1, J(this), lu(e), t));
	}
	equals(e) {
		return lo(J(this), lu(e));
	}
	toPlainDate(e) {
		return ku(jc(J(this).calendar, this, e));
	}
	toLocaleString(e = void 0, t = {}) {
		let n = J(this), r = new Po(e, Rc(tl(t)));
		return Bc(r, n, 1), r.format(mr(n));
	}
	toString(e = void 0) {
		return Ho(J(this), e);
	}
	toJSON() {
		return Ho(J(this));
	}
	valueOf() {
		return vl();
	}
}, J, yl, Sl);
function su(e) {
	return uu(Object.create(ou.prototype), e);
}
function J(e) {
	return cu(e) || _l();
}
function cu(e) {
	return au.get(e);
}
function lu(e, t) {
	if (g(e)) {
		let n = cu(e);
		return n ? (h(t), n) : Es(Nu(e), e, t);
	}
	let n = Fs(e, Ll);
	return h(t), n;
}
function uu(e, t) {
	return au.set(e, t), gl(e), e;
}
function du(e) {
	if (!g(e)) return;
	let t = Jl(e);
	return t ? [pl, t] : (t = Hl(e), t ? [fl, t] : (t = wu(e), t ? [ul, t] : (t = Au(e), t ? [ll, t] : (t = _u(e), t ? [dl, t] : (t = cu(e), t ? [sl, t] : (t = nu(e), t ? [cl, t] : (t = Ru(e), t ? [ml, t] : void 0)))))));
}
function fu(e) {
	return (du(e) || e.calendar !== void 0 || e.timeZone !== void 0) && v("Invalid bag"), e;
}
var pu = /*@__PURE__*/ new WeakMap(), mu = /*@__PURE__*/ hl(dl, class {
	constructor(e = 0, t = 0, n = 0, r = 0, i = 0, a = 0) {
		let o = tr(At(m, {
			hour: e,
			minute: t,
			second: n,
			millisecond: r,
			microsecond: i,
			nanosecond: a
		}));
		bu(this, Di(o));
	}
	static from(e, t = void 0) {
		return hu(vu(e, t));
	}
	static compare(e, t) {
		return io(vu(e), vu(t));
	}
	with(e, t = void 0) {
		return hu(Fl(gu(this), fu(e), t));
	}
	add(e) {
		return hu(na(gu(this), $(e))[0]);
	}
	subtract(e) {
		return hu(na(gu(this), Ha($(e)))[0]);
	}
	until(e, t = void 0) {
		return Z(kl(0, gu(this), vu(e), t));
	}
	since(e, t = void 0) {
		return Z(kl(1, gu(this), vu(e), t));
	}
	round(e) {
		let t = gu(this), [n, r, i] = Qe(e, 5);
		return hu(Li(t, qi(n, r), i)[0]);
	}
	equals(e) {
		return fo(gu(this), vu(e));
	}
	toLocaleString(e = void 0, t = {}) {
		let n = gu(this);
		return new Po(e, Rc(el(t))).format(ir(n));
	}
	toString(e = void 0) {
		return Go(gu(this), e);
	}
	toJSON() {
		return Go(gu(this));
	}
	valueOf() {
		return vl();
	}
}, gu, Dn);
function hu(e) {
	return bu(Object.create(mu.prototype), e);
}
function gu(e) {
	return _u(e) || _l();
}
function _u(e) {
	return pu.get(e);
}
function vu(e, t) {
	if (g(e)) {
		let n = _u(e);
		if (n) return h(t), n;
		let r = wu(e);
		if (r) return h(t), Di(r);
		let i = Hl(e);
		return i ? (h(t), Oc(i)) : Os(e, t);
	}
	let n = Rs(e);
	return h(t), n;
}
function yu(e) {
	return e === void 0 ? void 0 : vu(e);
}
function bu(e, t) {
	return pu.set(e, t), gl(e), e;
}
var xu = /*@__PURE__*/ new WeakMap(), Su = /*@__PURE__*/ hl(ul, class {
	constructor(e, t, n, r = 0, i = 0, a = 0, o = 0, s = 0, c = 0, l = void 0) {
		let u = mi(Mr(At(m, {
			year: e,
			month: t,
			day: n,
			hour: r,
			minute: i,
			second: a,
			millisecond: o,
			microsecond: s,
			nanosecond: c
		}))), d = Rl(l);
		Eu(this, Ei(u, d));
	}
	static from(e, t = void 0) {
		return Cu(Tu(e, t));
	}
	static compare(e, t) {
		return no(Tu(e), Tu(t));
	}
	get calendarId() {
		return cn(Y(this).calendar);
	}
	with(e, t = void 0) {
		return Cu(Ml(Y(this), fu(e), t));
	}
	withCalendar(e) {
		return Cu(Ei(Y(this), Fu(e)));
	}
	withPlainTime(e = void 0) {
		let t = Y(this);
		return Cu(Do(t, yu(e), t.calendar));
	}
	add(e, t = void 0) {
		let n = Y(this);
		return Cu(Ei(ta(n.calendar, n, $(e), h(t)), n.calendar));
	}
	subtract(e, t = void 0) {
		let n = Y(this);
		return Cu(Ei(ta(n.calendar, n, Ha($(e)), h(t)), n.calendar));
	}
	until(e, t = void 0) {
		return Z(El(0, Y(this), Tu(e), t));
	}
	since(e, t = void 0) {
		return Z(El(1, Y(this), Tu(e), t));
	}
	round(e) {
		let t = Y(this), [n, r, i] = Qe(e);
		return Cu(Ei(Ii(t, qi(n, r), i), t.calendar));
	}
	equals(e) {
		return so(Y(this), Tu(e));
	}
	toZonedDateTime(e, t = void 0) {
		return W(kc(Y(this), H(K(e)), tt(t)));
	}
	toPlainDate() {
		let e = Y(this);
		return ku(I(e, e.calendar));
	}
	toPlainTime() {
		return hu(Di(Y(this)));
	}
	toLocaleString(e = void 0, t = {}) {
		let n = Y(this), r = new Po(e, Rc(Qc(t)));
		return Bc(r, n), r.format(fr(n));
	}
	toString(e = void 0) {
		return Bo(Y(this), e);
	}
	toJSON() {
		return Bo(Y(this));
	}
	valueOf() {
		return vl();
	}
}, Y, bl, Cl, Dn);
function Cu(e) {
	return Eu(Object.create(Su.prototype), e);
}
function Y(e) {
	return wu(e) || _l();
}
function wu(e) {
	return xu.get(e);
}
function Tu(e, t) {
	if (g(e)) {
		let n = wu(e);
		if (n) return h(t), n;
		let r = Au(e);
		if (r) return h(t), Ei(M(r, er), r.calendar);
		let i = Hl(e);
		return i ? (h(t), Ec(i)) : ws(Nu(e), e, t);
	}
	let n = Ns(e, Ll);
	return h(t), n;
}
function Eu(e, t) {
	return xu.set(e, t), gl(e), e;
}
var Du = /*@__PURE__*/ new WeakMap(), Ou = /*@__PURE__*/ hl(ll, class {
	constructor(e, t, n, r = void 0) {
		let i = N(Nr(At(m, {
			year: e,
			month: t,
			day: n
		}))), a = Rl(r);
		Mu(this, I(i, a));
	}
	static from(e, t = void 0) {
		return ku(ju(e, t));
	}
	static compare(e, t) {
		return ro(ju(e), ju(t));
	}
	get calendarId() {
		return cn(X(this).calendar);
	}
	with(e, t = void 0) {
		return ku(jl(X(this), fu(e), t));
	}
	withCalendar(e) {
		return ku(I(X(this), Fu(e)));
	}
	add(e, t = void 0) {
		let n = X(this);
		return ku(I(ia(n.calendar, n, $(e), h(t)), n.calendar));
	}
	subtract(e, t = void 0) {
		let n = X(this);
		return ku(I(ia(n.calendar, n, Ha($(e)), h(t)), n.calendar));
	}
	until(e, t = void 0) {
		return Z(Dl(0, X(this), ju(e), t));
	}
	since(e, t = void 0) {
		return Z(Dl(1, X(this), ju(e), t));
	}
	equals(e) {
		return co(X(this), ju(e));
	}
	toZonedDateTime(e) {
		let t = g(e) ? {
			timeZone: e.timeZone,
			plainTime: e.plainTime
		} : { timeZone: e }, n = X(this), r = K(t.timeZone), i = t.plainTime, a = i === void 0 ? void 0 : vu(i);
		return W(Ac(n, H(r), a));
	}
	toPlainDateTime(e = void 0) {
		let t = X(this);
		return Cu(Do(t, yu(e), t.calendar));
	}
	toPlainYearMonth() {
		return su(Pc(X(this).calendar, this));
	}
	toPlainMonthDay() {
		return eu(Nc(X(this).calendar, this));
	}
	toLocaleString(e = void 0, t = {}) {
		let n = X(this), r = new Po(e, Rc($c(t)));
		return Bc(r, n), r.format(mr(n));
	}
	toString(e = void 0) {
		return Vo(X(this), e);
	}
	toJSON() {
		return Vo(X(this));
	}
	valueOf() {
		return vl();
	}
}, X, bl, Cl);
function ku(e) {
	return Mu(Object.create(Ou.prototype), e);
}
function X(e) {
	return Au(e) || _l();
}
function Au(e) {
	return Du.get(e);
}
function ju(e, t) {
	if (g(e)) {
		let n = Au(e);
		if (n) return h(t), n;
		let r = wu(e);
		if (r) return h(t), I(r, r.calendar);
		let i = Hl(e);
		return i ? (h(t), Dc(i)) : Ts(Nu(e), e, t);
	}
	let n = Ps(e, Ll);
	return h(t), n;
}
function Mu(e, t) {
	return Du.set(e, t), gl(e), e;
}
function Nu(e) {
	let t = Pu(e);
	return t === void 0 ? void 0 : t;
}
function Pu(e) {
	let { calendar: t } = e;
	if (t !== void 0) return Fu(t);
}
function Fu(e) {
	if (g(e)) {
		let t = Au(e) || wu(e) || Hl(e) || nu(e) || cu(e);
		return t || v(vt(e)), t.calendar;
	}
	return ((e) => Ll(Bs(j(e))))(e);
}
var Iu = /*@__PURE__*/ new WeakMap(), Lu = /*@__PURE__*/ hl(ml, class {
	constructor(e = 0, t = 0, n = 0, r = 0, i = 0, a = 0, o = 0, s = 0, c = 0, l = 0) {
		let u = Wa(At(ci, {
			years: e,
			months: t,
			weeks: n,
			days: r,
			hours: i,
			minutes: a,
			seconds: o,
			milliseconds: s,
			microseconds: c,
			nanoseconds: l
		}));
		Bu(this, Oi(u));
	}
	static from(e) {
		return Z($(e));
	}
	static compare(e, t, n = void 0) {
		return to(zu, $(e), $(t), n);
	}
	get sign() {
		return Q(this).sign;
	}
	get blank() {
		return !Q(this).sign;
	}
	with(e) {
		return Z(bc(Q(this), e));
	}
	negated() {
		return Z(Va(Q(this)));
	}
	abs() {
		return Z(Ba(Q(this)));
	}
	add(e) {
		return Z(Ra(0, Q(this), $(e)));
	}
	subtract(e) {
		return Z(Ra(1, Q(this), $(e)));
	}
	round(e) {
		return Z(za(zu, Q(this), e));
	}
	total(e) {
		return Sc(zu, Q(this), e);
	}
	toLocaleString(e = void 0, t) {
		let n = Q(this);
		return Intl.DurationFormat ? new Intl.DurationFormat(e, t).format(n) : Ko(n, t);
	}
	toString(e = void 0) {
		return Ko(Q(this), e);
	}
	toJSON() {
		return Ko(Q(this));
	}
	valueOf() {
		return vl();
	}
}, Q, Yr);
function Z(e) {
	return Bu(Object.create(Lu.prototype), e);
}
function Q(e) {
	return Ru(e) || _l();
}
function Ru(e) {
	return Iu.get(e);
}
function $(e) {
	return g(e) ? Ru(e) || ks(e) : zs(e);
}
function zu(e) {
	if (e !== void 0) {
		if (g(e)) {
			let t = Hl(e);
			if (t) return t;
			let n = Au(e);
			if (n) return n;
			let r = wu(e);
			return r ? I(r, r.calendar) : Ss(K, Nu(e), e);
		}
		return js(e, Ll);
	}
}
function Bu(e, t) {
	return Iu.set(e, t), gl(e), e;
}
var Vu = /*@__PURE__*/ Object.defineProperties({}, {
	...kt("Temporal.Now"),
	...Ot({
		timeZoneId() {
			return ol();
		},
		instant() {
			return ql(P(al()));
		},
		zonedDateTimeISO(e = ol()) {
			let t = H(K(e));
			return W(F(al(), t));
		},
		plainDateTimeISO(e = ol()) {
			return Cu(Ei(il(H(K(e)))));
		},
		plainDateISO(e = ol()) {
			return ku(I(il(H(K(e)))));
		},
		plainTimeISO(e = ol()) {
			return hu(Di(il(H(K(e)))));
		}
	})
}), Hu = /*@__PURE__*/ Object.defineProperties({}, {
	...kt("Temporal"),
	...Ot({
		PlainYearMonth: ou,
		PlainMonthDay: $l,
		PlainDate: Ou,
		PlainTime: mu,
		PlainDateTime: Su,
		ZonedDateTime: Bl,
		Instant: Kl,
		Duration: Lu,
		Now: Vu
	})
}), Uu = ne || Hu;
ne && Date.prototype.toTemporalInstant;
//#endregion
//#region src/utils/isValidTimeZone.ts
var Wu = (e) => {
	try {
		return new Intl.DateTimeFormat("en", { timeZone: e }), !/^[+-]/.test(e);
	} catch {
		return !1;
	}
}, Gu = (e, t) => {
	if (!Wu(t)) throw RangeError("Invalid workspace time zone.");
	if (!/^\d{4}-\d{2}-\d{2}$/.test(e)) throw RangeError("Workspace day must use YYYY-MM-DD.");
	let n = Uu.PlainDate.from(e);
	return {
		startsAt: n.toZonedDateTime(t).toInstant().toString(),
		endsAt: n.add({ days: 1 }).toZonedDateTime(t).toInstant().toString()
	};
}, Ku = t.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/), qu = t.object({
	start: Ku,
	end: Ku
}).refine((e) => e.start < e.end), Ju = t.object({
	timeZone: t.string().refine(Wu),
	workingDays: t.array(t.number().int().min(1).max(7)).min(1).max(7).refine((e) => new Set(e).size === e.length),
	halfDaySlots: t.object({
		morning: qu,
		afternoon: qu
	}).refine((e) => e.morning.end <= e.afternoon.start)
}), Yu = (e, t, n) => {
	Ju.parse(n), Gu(e, n.timeZone);
	let r = n.halfDaySlots[t], i = (t) => Uu.PlainDateTime.from(`${e}T${t}`).toZonedDateTime(n.timeZone, { disambiguation: "reject" }).toInstant().toString();
	return {
		startsAt: i(r.start),
		endsAt: i(r.end)
	};
}, Xu = (e, t) => {
	Ju.parse(t);
	let n = Uu.Instant.from(e), r = n.toZonedDateTimeISO(t.timeZone).toPlainDate().toString();
	for (let e of ["morning", "afternoon"]) {
		let i = Yu(r, e, t);
		if (Uu.Instant.compare(n, Uu.Instant.from(i.startsAt)) >= 0 && Uu.Instant.compare(n, Uu.Instant.from(i.endsAt)) < 0) return {
			day: r,
			halfDay: e
		};
	}
	return null;
}, Zu = (e) => Array.isArray(e) && e.length > 0, Qu = (e) => typeof e == "object" && !!e && !Array.isArray(e), $u = (t) => typeof t == "string" && e.includes(t), ed = (e) => {
	try {
		return JSON.parse(e);
	} catch {
		return null;
	}
}, td = (e) => Object.entries(e);
//#endregion
export { r as assertIsDefinedOrThrow, i as assertUnreachable, a as capitalize, o as escapeForIlike, s as findOrThrow, f as getAbsenceWarnings, p as getDoubleBookingWarnings, te as getPlanningWarnings, ee as getUnassignedWarnings, Xu as getWorkspaceDayHalfDayFromTimestamp, Gu as getWorkspaceDayRange, Yu as getWorkspaceHalfDayRange, n as isDefined, Zu as isNonEmptyArray, Qu as isPlainObject, $u as isValidLocale, Wu as isValidTimeZone, ed as parseJson, td as typedObjectEntries, Ju as workspacePlanningSettingsSchema };

//# sourceMappingURL=utils.mjs.map